(function () {
  var CHAT_IDS = ["sens-ai-root", "sens-ai-panel", "sens-ai-launcher", "sens-ai-toast"];

  function dedupeChatWidgets() {
    CHAT_IDS.forEach(function (id) {
      var nodes = document.querySelectorAll("#" + id);
      for (var i = nodes.length - 1; i > 0; i--) {
        nodes[i].remove();
      }
    });
  }

  function mountChatToBody() {
    CHAT_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    });
  }

  dedupeChatWidgets();

  if (window.__SENS_AI_BOOTED__) {
    return;
  }

  mountChatToBody();

  var rootMount = document.getElementById("sens-ai-root");
  var CONFIG = {
    apiUrl: "/apps/sens-ai/chat",
    streamApiUrl: "",
    streamTokenUrl: "/apps/sens-ai/stream-token",
    streamingEnabled: false,
    shopUrl: (rootMount && rootMount.getAttribute("data-shop-url")) || window.location.origin,
    maxWineResults: 20,
    maxMusicVideoResults: 60
  };
  if (rootMount) {
    var streamUrl = String(rootMount.getAttribute("data-stream-api-url") || "").trim();
    CONFIG.streamApiUrl = streamUrl;
    CONFIG.streamingEnabled =
      rootMount.getAttribute("data-stream-enabled") !== "0" && streamUrl.length > 0;
  }
  var STORAGE_LAYOUT = "sens_ai_panel_layout";
  var STORAGE_MIN = "sens_ai_panel_minimized";
  var STORAGE_SESSION = "sens_ai_chat_session";
  var STORAGE_NAV_OPEN = "sens_ai_open_after_nav";
  var STORAGE_THEME = "sens_ai_panel_theme";
  var DEFAULT_W = 420;
  var DEFAULT_H = 680;
  var MIN_W = 320;
  var MIN_H = 360;
  var MINIMIZED_H = 52;
  var MARGIN = 16;
  var MOBILE = 768;
  var MOBILE_DOCK_H_RATIO = 0.78;

  var panel = document.getElementById("sens-ai-panel");
  var launcher = document.getElementById("sens-ai-launcher");
  var dragHandle = document.getElementById("sens-ai-drag-handle");
  var newChatBtn = document.getElementById("sens-ai-new-chat");
  var maximizeBtn = document.getElementById("sens-ai-maximize");
  var minimizeBtn = document.getElementById("sens-ai-minimize");
  var messagesEl = document.getElementById("sens-ai-messages");
  var formEl = document.getElementById("sens-ai-form");
  var inputEl = document.getElementById("sens-ai-input");
  var sendEl = document.getElementById("sens-ai-send");
  var toastEl = document.getElementById("sens-ai-toast");
  var photoInputEl = document.getElementById("sens-ai-photo-input");
  var attachBtnEl = document.getElementById("sens-ai-attach-btn");
  var attachMenuEl = document.getElementById("sens-ai-attach-menu");
  var uploadImageBtnEl = document.getElementById("sens-ai-upload-image-btn");
  var takePhotoBtnEl = document.getElementById("sens-ai-take-photo-btn");
  var inputWrapEl = document.getElementById("sens-ai-input-wrap");
  var photoPreviewEl = document.getElementById("sens-ai-photo-preview");
  var photoPreviewImgEl = document.getElementById("sens-ai-photo-preview-img");
  var photoRemoveEl = document.getElementById("sens-ai-photo-remove");
  var themeToggleBtn = document.getElementById("sens-ai-theme-toggle");
  var cyberLaunchOverlayEl = document.getElementById("sens-ai-cyber-launch");
  var cyberLaunchVideoEl = document.getElementById("sens-ai-cyber-launch-video");
  var cyberLaunchSkipEl = document.getElementById("sens-ai-cyber-launch-skip");
  var cyberLaunchAudioEl = document.getElementById("sens-ai-cyber-launch-audio");
  var headerOrbWrap = document.getElementById("sens-ai-header-orb");
  var headerOrbCanvas = document.getElementById("sens-ai-header-orb-canvas");
  var nebulaHeaderOrb = null;
  var attachMenuOpen = false;
  var chatTheme = "modern";

  if (!panel || !launcher) return;

  window.__SENS_AI_BOOTED__ = true;

  var layout = null;
  var expandedLayout = null;
  var preMaximizeLayout = null;
  var isMinimized = false;
  var isMaximized = false;
  var isDragging = false;
  var isResizing = false;
  var dragState = null;
  var resizeState = null;
  var headerClickStart = null;
  var HEADER_CLICK_THRESHOLD = 6;
  var history = [];
  var lastWines = [];
  var pendingCartIndices = [];
  var chatSessionId = "";
  var busy = false;
  var currentAbortController = null;
  var pendingPhoto = null;
  var MAX_IMAGE_DIM = 1280;
  var JPEG_QUALITY = 0.82;
  var WELCOME_MESSAGE =
    "Hi — I'm Mirai, your SENS wine advisor. Tell me what you're eating, celebrating, or in the mood for, and I'll help you find something lovely from our cellar.";
  var BUTLER_AVATAR_LABEL = "Mirai";
  var BUTLER_AVATAR_SIZE = 52;
  var BUTLER_AVATAR_SVG =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M8 4h8l-1.15 9.1a3.15 3.15 0 0 1-5.7 0L8 4z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/>' +
    '<path d="M12 13.2v2.8M9.2 19h5.6" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>' +
    "</svg>";
  var CART_ADD_FAIL_MESSAGE_EN =
    "Oops — I can't add this to your cart right now. Please try again later, or pick another wine.";
  var CART_ADD_FAIL_MESSAGE_ZH =
    "唔好意思，暫時加唔到住，請遲啲再試或試其他酒啦！";

  var BUTLER_AVATAR_INTRO_KEY = "sens_ai_butler_avatar_intro_played";
  var butlerAvatarIntroPlaying = false;

  function getButlerAvatarUrl() {
    if (!rootMount) return "";
    return String(rootMount.getAttribute("data-butler-avatar-url") || "").trim();
  }

  function getButlerAvatarVideoUrl() {
    if (!rootMount) return "";
    return String(rootMount.getAttribute("data-butler-avatar-video-url") || "").trim();
  }

  function hasButlerAvatarIntroPlayed() {
    try {
      return sessionStorage.getItem(BUTLER_AVATAR_INTRO_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function markButlerAvatarIntroPlayed() {
    try {
      sessionStorage.setItem(BUTLER_AVATAR_INTRO_KEY, "1");
    } catch (e) {}
  }

  function finishButlerAvatarIntro(avatar) {
    butlerAvatarIntroPlaying = false;
    markButlerAvatarIntroPlayed();
    if (avatar) applyButlerAvatarContent(avatar, { forceStill: true });
  }

  function getButlerAdvisorName() {
    if (!rootMount) return "Mirai みらい";
    var name = String(rootMount.getAttribute("data-butler-advisor-name") || "Mirai みらい").trim();
    return name || "Mirai みらい";
  }

  function applyButlerAvatarContent(avatar, options) {
    options = options || {};
    if (!avatar) return;
    if (butlerAvatarIntroPlaying && avatar.dataset.avatarIntroPlaying === "1" && !options.forceStill) {
      return;
    }

    var url = getButlerAvatarUrl();
    var videoUrl = getButlerAvatarVideoUrl();
    avatar.classList.remove("sens-ai-msg__avatar--video");
    avatar.classList.toggle("sens-ai-msg__avatar--image", !!url);
    avatar.textContent = "";
    delete avatar.dataset.avatarIntroPlaying;

    if (
      !options.forceStill &&
      options.playIntro &&
      videoUrl &&
      url &&
      !hasButlerAvatarIntroPlayed() &&
      !isCyberChatTheme()
    ) {
      avatar.classList.add("sens-ai-msg__avatar--video");
      avatar.classList.add("sens-ai-msg__avatar--image");
      avatar.dataset.avatarIntroPlaying = "1";
      butlerAvatarIntroPlaying = true;

      var video = document.createElement("video");
      video.className = "sens-ai-msg__avatar-video";
      video.src = videoUrl;
      video.muted = true;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("preload", "auto");
      video.width = BUTLER_AVATAR_SIZE;
      video.height = BUTLER_AVATAR_SIZE;
      video.addEventListener("ended", function () {
        finishButlerAvatarIntro(avatar);
      });
      video.addEventListener("error", function () {
        finishButlerAvatarIntro(avatar);
      });
      avatar.appendChild(video);

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {
          finishButlerAvatarIntro(avatar);
        });
      }
      return;
    }

    if (url) {
      var img = document.createElement("img");
      img.src = url;
      img.alt = "";
      img.width = BUTLER_AVATAR_SIZE;
      img.height = BUTLER_AVATAR_SIZE;
      img.loading = "lazy";
      img.decoding = "async";
      avatar.appendChild(img);
      return;
    }
    avatar.innerHTML = BUTLER_AVATAR_SVG;
  }

  function maybePlayButlerAvatarIntro() {
    if (isMinimized || isCyberChatTheme() || hasButlerAvatarIntroPlayed()) return false;
    if (!getButlerAvatarVideoUrl() || !getButlerAvatarUrl()) return false;
    var firstAvatar = messagesEl && messagesEl.querySelector(".sens-ai-msg--bot .sens-ai-msg__avatar");
    if (!firstAvatar) return false;
    applyButlerAvatarContent(firstAvatar, { playIntro: true });
    return butlerAvatarIntroPlaying;
  }

  function createButlerSender() {
    var advisorName = getButlerAdvisorName();
    var sender = document.createElement("div");
    sender.className = "sens-ai-msg__sender";

    var avatar = document.createElement("div");
    avatar.className = "sens-ai-msg__avatar";
    avatar.setAttribute("role", "img");
    avatar.setAttribute("aria-label", advisorName + ", " + BUTLER_AVATAR_LABEL);
    avatar.setAttribute("title", advisorName);
    applyButlerAvatarContent(avatar);

    var name = document.createElement("p");
    name.className = "sens-ai-msg__sender-name";
    name.textContent = advisorName;

    sender.appendChild(avatar);
    sender.appendChild(name);
    return sender;
  }

  function ensureBotMessageAvatars() {
    messagesEl.querySelectorAll(".sens-ai-msg--bot").forEach(function (msg) {
      var sender = msg.querySelector(":scope > .sens-ai-msg__sender");
      if (sender) {
        var avatar = sender.querySelector(".sens-ai-msg__avatar");
        if (avatar) applyButlerAvatarContent(avatar);
        var nameEl = sender.querySelector(".sens-ai-msg__sender-name");
        if (nameEl) nameEl.textContent = getButlerAdvisorName();
        return;
      }
      var bareAvatar = msg.querySelector(":scope > .sens-ai-msg__avatar");
      if (bareAvatar) {
        bareAvatar.replaceWith(createButlerSender());
        return;
      }
      msg.insertBefore(createButlerSender(), msg.firstChild);
    });
  }

  function isMobile() {
    return window.innerWidth <= MOBILE;
  }

  function viewportMetrics() {
    var vv = window.visualViewport;
    if (vv) {
      return {
        width: vv.width,
        height: vv.height,
        offsetTop: vv.offsetTop || 0,
        offsetLeft: vv.offsetLeft || 0
      };
    }
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      offsetTop: 0,
      offsetLeft: 0
    };
  }

  function mobileDockLayout() {
    var vp = viewportMetrics();
    var w = Math.round(vp.width);
    var ratio = isMaximized ? 1 : MOBILE_DOCK_H_RATIO;
    var maxH = vp.height - (isMaximized ? 0 : 40);
    var h = Math.round(Math.min(vp.height * ratio, maxH));
    return {
      x: Math.round(vp.offsetLeft),
      y: Math.round(vp.offsetTop + vp.height - h),
      width: w,
      height: h
    };
  }

  function maximizeLayout() {
    if (isMobile()) {
      var vp = viewportMetrics();
      return {
        x: Math.round(vp.offsetLeft),
        y: Math.round(vp.offsetTop),
        width: Math.round(vp.width),
        height: Math.round(vp.height)
      };
    }
    return {
      x: MARGIN,
      y: MARGIN,
      width: window.innerWidth - MARGIN * 2,
      height: window.innerHeight - MARGIN * 2
    };
  }

  function setButtonTip(btn, tip) {
    if (!btn) return;
    btn.setAttribute("data-tip", tip);
    btn.title = tip;
    btn.setAttribute("aria-label", tip);
  }

  function syncMaximizeButton() {
    if (!maximizeBtn) return;
    if (isMaximized) {
      maximizeBtn.textContent = "⤢";
      setButtonTip(maximizeBtn, "Restore size · 還原大小");
    } else {
      maximizeBtn.textContent = "⛶";
      setButtonTip(maximizeBtn, "Maximize · 放大");
    }
  }

  function setMaximized(max) {
    if (isMinimized || isMobile() && isMinimized) return;
    if (max === isMaximized) return;
    isMaximized = max;
    panel.classList.toggle("is-maximized", max);
    syncMaximizeButton();
    if (max) {
      preMaximizeLayout = layout;
      applyLayout(maximizeLayout());
      expandedLayout = layout;
      return;
    }
    if (preMaximizeLayout) {
      applyLayout(preMaximizeLayout);
      expandedLayout = layout;
      preMaximizeLayout = null;
    } else if (!isMobile()) {
      applyLayout(expandedLayout || defaultLayout());
    } else {
      applyLayout(mobileDockLayout());
    }
  }

  function defaultLayout() {
    if (isMobile()) {
      return mobileDockLayout();
    }
    var w = DEFAULT_W;
    var h = DEFAULT_H;
    return {
      x: Math.max(MARGIN, window.innerWidth - w - MARGIN),
      y: Math.max(MARGIN, window.innerHeight - h - MARGIN),
      width: w,
      height: h
    };
  }

  function syncMobileMode() {
    panel.classList.toggle("sens-ai-panel--mobile-dock", isMobile());
  }

  function clampLayout(next, opts) {
    opts = opts || {};
    if (isMaximized && !isMinimized) {
      return next;
    }
    if (isMobile() && !isMinimized && !opts.allowFreePosition) {
      return mobileDockLayout();
    }
    var minW = opts.minWidth || MIN_W;
    var minH = opts.minHeight || MIN_H;
    var maxW = window.innerWidth - MARGIN * 2;
    var maxH = window.innerHeight - MARGIN * 2;
    var width = Math.max(minW, Math.min(next.width, maxW));
    var height = Math.max(minH, Math.min(next.height, maxH));
    var x = Math.max(MARGIN, Math.min(next.x, window.innerWidth - width - MARGIN));
    var y = Math.max(MARGIN, Math.min(next.y, window.innerHeight - height - MARGIN));
    return { x: x, y: y, width: width, height: height };
  }

  function loadMinimizedPreference() {
    try {
      sessionStorage.removeItem(STORAGE_NAV_OPEN);
    } catch (e) {}
    return true;
  }

  var CHAT_THEME_ORDER = ["modern", "classic", "cyber"];

  function normalizeChatTheme(value) {
    if (value === "classic" || value === "cyber") return value;
    return "modern";
  }

  function nextChatTheme(current) {
    var idx = CHAT_THEME_ORDER.indexOf(normalizeChatTheme(current));
    if (idx < 0) return "modern";
    return CHAT_THEME_ORDER[(idx + 1) % CHAT_THEME_ORDER.length];
  }

  function chatThemeLabel(theme) {
    if (theme === "classic") return "Classic";
    if (theme === "cyber") return "Cyber";
    return "Modern";
  }

  function isCyberChatTheme() {
    return chatTheme === "cyber";
  }

  function destroyNebulaOrbs() {
    if (nebulaHeaderOrb) {
      nebulaHeaderOrb.destroy();
      nebulaHeaderOrb = null;
    }
  }

  function resizeNebulaOrbs() {
    if (nebulaHeaderOrb && nebulaHeaderOrb.resize) nebulaHeaderOrb.resize();
  }

  function syncNebulaOrbs() {
    destroyNebulaOrbs();
    if (!window.SensNebulaOrb || typeof window.SensNebulaOrb.mount !== "function") return;

    if (!isCyberChatTheme() || isMinimized) {
      if (headerOrbWrap) {
        headerOrbWrap.hidden = true;
        headerOrbWrap.setAttribute("aria-hidden", "true");
      }
      return;
    }

    if (headerOrbWrap && headerOrbCanvas) {
      headerOrbWrap.hidden = false;
      headerOrbWrap.setAttribute("aria-hidden", "false");
      var mountHeaderOrb = function () {
        if (!isCyberChatTheme() || isMinimized || !headerOrbCanvas) return;
        var rect = headerOrbCanvas.getBoundingClientRect();
        if (rect.width < 8 || rect.height < 8) {
          window.requestAnimationFrame(mountHeaderOrb);
          return;
        }
        nebulaHeaderOrb = window.SensNebulaOrb.mount(headerOrbCanvas, {
          particleCount: 7200,
          radius: 1.1,
          pointScale: 1.35,
          rotateSpeed: 0.55,
          tiltAngle: 0.26,
          cameraDistance: 2.05,
          lookAtY: -0.58,
          sphereOffsetY: -0.2,
          hoverStrength: 1.05,
          blobFalloff: 1.45,
          pushStrength: 0.19,
          pushJitter: 0.075,
          smudgeStrength: 0.28,
          rippleStrength: 0.048,
          rippleSpeed: 3.5,
          swirlStrength: 0.092,
          swirlSpeed: 2.75,
          pointerSmooth: 0.14,
          hoverSmooth: 0.075,
          hoverSmoothOut: 0.02,
          pointerReturnDecay: 0.965,
          staleSampleMs: 200,
          velocityMomentumDecay: 0.965,
          speedMomentumDecay: 0.975,
          velocityMax: 7.5,
          velocitySmoothing: 0.3,
          elasticStiffness: 190,
          elasticDamping: 12,
          elasticGain: 1.2,
          hoverAnimSlowdown: 0.34,
          noiseFreq: 2.6,
          noiseAmp: 0.006,
          noiseSpeed: 0.32,
          mouseTiltMax: 0.16,
          mouseTiltLerp: 0.05,
          additiveBlending: true,
          colorHi: "#00f0ff",
          colorLo: "#0c2844",
          colorAccent: "#ff5cb0",
          interactionElement: dragHandle,
        });
      };
      window.requestAnimationFrame(mountHeaderOrb);
    }
  }

  function loadChatThemePreference() {
    try {
      var saved = localStorage.getItem(STORAGE_THEME);
      return normalizeChatTheme(saved);
    } catch (e) {
      return "modern";
    }
  }

  function saveChatThemePreference(theme) {
    try {
      localStorage.setItem(STORAGE_THEME, normalizeChatTheme(theme));
    } catch (e) {}
  }

  function syncThemeToggleButton() {
    if (!themeToggleBtn) return;
    var nextTheme = nextChatTheme(chatTheme);
    themeToggleBtn.setAttribute("aria-pressed", chatTheme !== "modern" ? "true" : "false");
    themeToggleBtn.setAttribute("data-theme", chatTheme);
    themeToggleBtn.classList.toggle("is-classic", chatTheme === "classic");
    themeToggleBtn.classList.toggle("is-cyber", chatTheme === "cyber");
    var nextLabel = chatThemeLabel(nextTheme);
    themeToggleBtn.setAttribute("data-tip", nextLabel + " theme · " + (nextTheme === "classic" ? "經典" : nextTheme === "cyber" ? "賽博" : "現代") + "主題");
    themeToggleBtn.setAttribute("title", "Switch to " + nextLabel + " theme");
    themeToggleBtn.setAttribute("aria-label", "Switch to " + nextLabel + " theme");
  }

  function applyClassicReadMoreOverrides() {
    if (!messagesEl) return;
    messagesEl.querySelectorAll("[data-read-more]").forEach(function (wrap) {
      var content = wrap.querySelector(".sens-ai-read-more__content");
      var full = wrap.getAttribute("data-read-more-full") || wrap.getAttribute("data-read-more-preview") || "";
      wrap.classList.add("is-expanded");
      if (!content || !full) return;
      if (wrap.classList.contains("sens-ai-read-more--reply")) {
        var wines = [];
        var rawWines = wrap.getAttribute("data-read-more-wines") || "";
        if (rawWines) {
          try {
            wines = JSON.parse(rawWines);
          } catch (e) {
            wines = [];
          }
        }
        content.innerHTML = formatReply(full, wines);
      } else {
        content.textContent = full;
      }
    });
  }

  var MODERN_CONCRETE_BG_URL =
    (rootMount && rootMount.getAttribute("data-modern-concrete-bg-url")) ||
    "https://mirai-454148902141-ap-northeast-1-an.s3.ap-northeast-1.amazonaws.com/concrete1.png";
  var CLASSIC_PAPER_BG_URL =
    (rootMount && rootMount.getAttribute("data-classic-paper-bg-url")) ||
    "https://mirai-454148902141-ap-northeast-1-an.s3.ap-northeast-1.amazonaws.com/antiquepaper.png";

  function applyThemePanelBackground() {
    var inner = panel && panel.querySelector(".sens-ai-panel__inner");
    if (!inner) return;
    inner.style.removeProperty("--sens-modern-concrete-bg");
    inner.style.removeProperty("--sens-classic-paper-bg");
    if (chatTheme === "modern" && MODERN_CONCRETE_BG_URL) {
      inner.style.setProperty("--sens-modern-concrete-bg", 'url("' + MODERN_CONCRETE_BG_URL + '")');
      return;
    }
    if (chatTheme === "classic" && CLASSIC_PAPER_BG_URL) {
      inner.style.setProperty("--sens-classic-paper-bg", 'url("' + CLASSIC_PAPER_BG_URL + '")');
    }
  }

  function applyChatTheme(theme) {
    chatTheme = normalizeChatTheme(theme);
    panel.classList.toggle("sens-ai-panel--classic", chatTheme === "classic");
    panel.classList.toggle("sens-ai-panel--modern", chatTheme === "modern");
    panel.classList.toggle("sens-ai-panel--cyber", chatTheme === "cyber");
    if (launcher) {
      launcher.classList.toggle("sens-ai-launcher--modern", chatTheme === "modern");
      launcher.classList.toggle("sens-ai-launcher--classic", chatTheme === "classic");
      launcher.classList.toggle("sens-ai-launcher--cyber", chatTheme === "cyber");
    }
    applyThemePanelBackground();
    syncThemeToggleButton();
    saveChatThemePreference(chatTheme);
    if (chatTheme === "classic" || chatTheme === "cyber") applyClassicReadMoreOverrides();
    if (chatTheme === "cyber" && messagesEl) {
      messagesEl.querySelectorAll(".sens-ai-msg--bot .sens-ai-msg__bubble").forEach(function (bubble) {
        if (bubble.dataset.cyberRevealed === "1") return;
        finalizeBotBubble(bubble);
      });
    }
    syncNebulaOrbs();
    ensureBotMessageAvatars();
    syncProductBarThemes();
  }

  function toggleChatTheme() {
    applyChatTheme(nextChatTheme(chatTheme));
  }

  var CYBER_REVEAL_SKIP =
    "a, button, input, select, textarea, label, [data-read-more], .sens-ai-wine-grid, .sens-ai-msg__wines, .sens-ai-about-hero, script, style";

  var CYBER_ABOUT_OWNER_IMAGE =
    (rootMount && rootMount.getAttribute("data-cyber-owner-image-url")) ||
    "https://mirai-454148902141-ap-northeast-1-an.s3.ap-northeast-1.amazonaws.com/wilson3.jpg";
  var CYBER_ABOUT_OWNER_IMAGE_FALLBACK =
    (rootMount && rootMount.getAttribute("data-cyber-owner-image-fallback")) || "";

  var CYBER_LAUNCH_VIDEO_PLAYED_KEY = "sens_ai_cyber_launch_video_played";

  function getCyberLaunchVideoUrl() {
    if (!rootMount) return "";
    return String(rootMount.getAttribute("data-cyber-launch-video-url") || "").trim();
  }

  function hasCyberLaunchVideoPlayed() {
    try {
      return sessionStorage.getItem(CYBER_LAUNCH_VIDEO_PLAYED_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function markCyberLaunchVideoPlayed() {
    try {
      sessionStorage.setItem(CYBER_LAUNCH_VIDEO_PLAYED_KEY, "1");
    } catch (e) {}
  }

  function isCyberLaunchVideoActive() {
    return !!(
      cyberLaunchOverlayEl &&
      !cyberLaunchOverlayEl.hidden &&
      cyberLaunchOverlayEl.classList.contains("is-active")
    );
  }

  function updateCyberLaunchAudioIndicator() {
    if (!cyberLaunchAudioEl || !cyberLaunchVideoEl) return;
    var isMuted = !!cyberLaunchVideoEl.muted;
    cyberLaunchAudioEl.classList.toggle("is-audio-on", !isMuted);
    cyberLaunchVideoEl.title = isMuted
      ? "Tap video to turn sound on"
      : "Tap video to turn sound off";
  }

  function setCyberLaunchVideoMuted(muted) {
    if (!cyberLaunchVideoEl) return;
    cyberLaunchVideoEl.muted = !!muted;
    updateCyberLaunchAudioIndicator();
  }

  function toggleCyberLaunchVideoAudio() {
    if (!cyberLaunchVideoEl || !isCyberLaunchVideoActive()) return;
    setCyberLaunchVideoMuted(!cyberLaunchVideoEl.muted);
    if (!cyberLaunchVideoEl.muted && cyberLaunchVideoEl.paused) {
      var resumePromise = cyberLaunchVideoEl.play();
      if (resumePromise && typeof resumePromise.catch === "function") {
        resumePromise.catch(function () {});
      }
    }
  }

  function dismissCyberLaunchVideo() {
    if (!cyberLaunchOverlayEl) return;
    cyberLaunchOverlayEl.classList.remove("is-active");
    cyberLaunchOverlayEl.hidden = true;
    cyberLaunchOverlayEl.setAttribute("aria-hidden", "true");
    panel.classList.remove("sens-ai-panel--launch-video");
    if (cyberLaunchVideoEl) {
      cyberLaunchVideoEl.pause();
      cyberLaunchVideoEl.removeAttribute("src");
      cyberLaunchVideoEl.load();
      setCyberLaunchVideoMuted(true);
    }
  }

  function finishCyberLaunchVideo() {
    markCyberLaunchVideoPlayed();
    dismissCyberLaunchVideo();
  }

  function playCyberLaunchVideo() {
    if (!isCyberChatTheme() || isMinimized || hasCyberLaunchVideoPlayed()) return false;
    var src = getCyberLaunchVideoUrl();
    if (!src || !cyberLaunchOverlayEl || !cyberLaunchVideoEl) return false;

    dismissCyberLaunchVideo();
    setCyberLaunchVideoMuted(true);
    cyberLaunchVideoEl.playsInline = true;
    cyberLaunchVideoEl.setAttribute("playsinline", "");
    cyberLaunchVideoEl.src = src;
    cyberLaunchVideoEl.load();

    cyberLaunchOverlayEl.hidden = false;
    cyberLaunchOverlayEl.setAttribute("aria-hidden", "false");
    cyberLaunchOverlayEl.classList.add("is-active");
    panel.classList.add("sens-ai-panel--launch-video");

    var playPromise = cyberLaunchVideoEl.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {
        finishCyberLaunchVideo();
      });
    }
    return true;
  }

  function focusChatInputUnlessLaunchVideo() {
    if (!isCyberLaunchVideoActive() && inputEl) inputEl.focus();
  }

  function skipCyberLaunchVideoToChat() {
    if (!isCyberLaunchVideoActive()) return;
    finishCyberLaunchVideo();
    focusChatInputUnlessLaunchVideo();
  }

  function isAboutSensUserMessage(message) {
    return /\b(?:about\s+sens|about\s+us|who\s+is\s+sens|tell\s+me\s+about\s+sens|our\s+story)\b/i.test(
      String(message || "").trim()
    );
  }

  function shouldShowAboutSensHero(meta, userMessage, replyText) {
    if (!isCyberChatTheme()) return false;
    if (meta && meta.mode === "about_sens") return true;
    if (!isAboutSensUserMessage(userMessage)) return false;
    return /\b(?:mission\s*&\s*philosophy|winston\s+wong|our\s+story|sens\s+wine\s+cellar)\b/i.test(
      String(replyText || "")
    );
  }

  var REPLY_TEXT_WITH_WINES_MODES = {
    general_chat: true,
    education: true,
    knowledge_education: true,
    knowledge_catalog: true,
    food_for_wine_knowledge: true,
    about_sens: true,
    store_info: true,
    greeting: true,
    session_recall: true,
    session_preference_recall: true,
    pairing_catalog: true,
    pairing_hybrid: true,
  };

  function shouldShowReplyBubbleWithWineCards(meta, cardWines, userMessage, bubbleText) {
    if (!cardWines || !cardWines.length) return true;
    if (!String(bubbleText || "").trim()) return false;
    if (shouldShowAboutSensHero(meta, userMessage, bubbleText)) return true;
    if (meta && meta.cardsOnly) return false;
    var mode = meta && meta.mode ? String(meta.mode) : "";
    if (REPLY_TEXT_WITH_WINES_MODES[mode]) return true;
    return false;
  }

  function normalizeChatReply(data) {
    var wines = data && Array.isArray(data.wines) ? data.wines : [];
    var raw = data && typeof data.reply === "string" ? data.reply : "";
    if (data && data.cards_only && wines.length) return "";
    if (raw.trim()) return raw;
    if (wines.length) return "";
    return "No reply received.";
  }

  function buildAboutSensHeroHtml(heroImageUrl) {
    if (!isCyberChatTheme()) return "";
    var src = String(heroImageUrl || CYBER_ABOUT_OWNER_IMAGE).trim();
    if (!src) return "";
    return (
      '<figure class="sens-ai-about-hero">' +
      '<img class="sens-ai-about-hero__img" src="' +
      escapeHtml(src) +
      '" alt="Winston Wong, founder of SENS Wine Cellar" loading="eager" decoding="async" referrerpolicy="no-referrer">' +
      "</figure>"
    );
  }

  function attachAboutHeroImageHandlers(bubble) {
    if (!bubble) return;
    var img = bubble.querySelector(".sens-ai-about-hero__img");
    if (!img) return;
    var fallbacks = [];
    if (CYBER_ABOUT_OWNER_IMAGE_FALLBACK && CYBER_ABOUT_OWNER_IMAGE_FALLBACK !== img.src) {
      fallbacks.push(CYBER_ABOUT_OWNER_IMAGE_FALLBACK);
    }
    var attempt = 0;
    img.addEventListener("error", function onHeroError() {
      if (attempt < fallbacks.length) {
        img.src = fallbacks[attempt++];
        return;
      }
      img.removeEventListener("error", onHeroError);
      var figure = img.closest(".sens-ai-about-hero");
      if (figure) figure.remove();
      bubble.classList.remove("sens-ai-msg__bubble--about-sens");
    });
    function revealHeroImage() {
      if (!isCyberChatTheme() || img.classList.contains("sens-ai-about-hero__img--visible")) return;
      requestAnimationFrame(function () {
        img.classList.add("sens-ai-about-hero__img--visible");
      });
    }
    if (img.complete && img.naturalWidth) revealHeroImage();
    else img.addEventListener("load", revealHeroImage, { once: true });
  }

  function prepareBotBubbleForCyberReveal(bubble) {
    if (!isCyberChatTheme() || !bubble) return;
    bubble.classList.add("sens-ai-msg__bubble--cyber-pending-reveal");
  }

  function applyCyberRevealToBubble(bubble) {
    if (!isCyberChatTheme() || !bubble) return;
    var msg = bubble.closest(".sens-ai-msg");
    if (!msg || !msg.classList.contains("sens-ai-msg--bot")) return;
    if (msg.classList.contains("sens-ai-msg--loading")) return;
    if (bubble.dataset.cyberRevealed === "1") return;
    bubble.dataset.cyberRevealed = "1";
    bubble.classList.add("sens-ai-msg__bubble--cyber-pending-reveal");
    bubble.classList.add("sens-ai-msg__bubble--cyber-reveal");

    var index = 0;
    var walker = document.createTreeWalker(bubble, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (parent.closest(CYBER_REVEAL_SKIP)) return NodeFilter.FILTER_REJECT;
        if (!String(node.nodeValue || "").trim()) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(function (textNode) {
      var parts = String(textNode.nodeValue).split(/(\s+)/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          frag.appendChild(document.createTextNode(part));
          return;
        }
        var span = document.createElement("span");
        span.className = "sens-ai-cyber-word";
        span.style.setProperty("--cyber-i", String(index++));
        span.textContent = part;
        frag.appendChild(span);
      });
      if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
    });
    bubble.classList.remove("sens-ai-msg__bubble--cyber-pending-reveal");
  }

  function finalizeBotBubble(bubble) {
    if (!bubble) return;
    applyCyberRevealToBubble(bubble);
  }

  function createChatSessionId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return (
      "sess-" +
      Date.now().toString(36) +
      "-" +
      Math.random().toString(36).slice(2, 11)
    );
  }

  function rotateChatSessionId() {
    chatSessionId = createChatSessionId();
    return chatSessionId;
  }

  function ensureChatSessionId() {
    if (chatSessionId) return chatSessionId;
    chatSessionId = createChatSessionId();
    return chatSessionId;
  }

  function saveChatSession() {
    try {
      sessionStorage.setItem(
        STORAGE_SESSION,
        JSON.stringify({
          html: messagesEl.innerHTML,
          history: history,
          lastWines: lastWines,
          pendingCartIndices: pendingCartIndices,
          chatSessionId: chatSessionId
        })
      );
    } catch (e) {}
  }

  function restoreChatSession() {
    try {
      var raw = sessionStorage.getItem(STORAGE_SESSION);
      if (!raw) return false;
      var data = JSON.parse(raw);
      if (data && data.html) {
        messagesEl.innerHTML = data.html;
        ensureBotMessageAvatars();
        messagesEl.querySelectorAll(".sens-ai-wine-carousel").forEach(function (carousel) {
          delete carousel.dataset.hintReady;
        });
        setupWineCarouselHints(messagesEl);
      }
      if (data && Array.isArray(data.history)) {
        history = data.history;
      }
      if (data && Array.isArray(data.lastWines)) {
        lastWines = data.lastWines;
      }
      if (data && Array.isArray(data.pendingCartIndices)) {
        pendingCartIndices = data.pendingCartIndices;
      }
      if (data && typeof data.chatSessionId === "string" && data.chatSessionId.trim()) {
        chatSessionId = data.chatSessionId.trim();
      }
      return !!(data && data.html);
    } catch (e) {}
    return false;
  }

  function clearChatSession() {
    try {
      sessionStorage.removeItem(STORAGE_SESSION);
    } catch (e) {}
  }

  function persistOpenForNavigation() {
    try {
      localStorage.setItem(STORAGE_MIN, "0");
      sessionStorage.setItem(STORAGE_NAV_OPEN, "1");
    } catch (e) {}
    saveChatSession();
  }

  function isWineProductLink(link) {
    if (!link || !link.href) return false;
    if (link.getAttribute("href") === "#") return false;
    return (
      link.classList.contains("sens-ai-btn--link") ||
      link.classList.contains("sens-ai-wine-comments-link") ||
      (link.closest(".sens-ai-wine-title") && link.closest("#sens-ai-panel"))
    );
  }

  function handleWineProductNavigation(event) {
    var panelLink = event.target.closest(
      "#sens-ai-panel a.sens-ai-btn--link, #sens-ai-panel .sens-ai-wine-title a, #sens-ai-panel a.sens-ai-wine-comments-link, #sens-ai-panel a.sens-ai-panel__view-cart, #sens-ai-panel a.sens-ai-panel__checkout"
    );
    if (!panelLink) return;
    if (
      !panelLink.classList.contains("sens-ai-panel__view-cart") &&
      !panelLink.classList.contains("sens-ai-panel__checkout") &&
      !isWineProductLink(panelLink)
    ) {
      return;
    }
    persistOpenForNavigation();
  }

  function loadLayout() {
    if (isMobile()) {
      return mobileDockLayout();
    }
    try {
      var raw = localStorage.getItem(STORAGE_LAYOUT);
      if (raw) return clampLayout(JSON.parse(raw), { allowFreePosition: true });
    } catch (e) {}
    return defaultLayout();
  }

  function saveLayout(next) {
    try {
      localStorage.setItem(STORAGE_LAYOUT, JSON.stringify(next));
    } catch (e) {}
  }

  function applyLayout(next) {
    layout = clampLayout(next, isMinimized ? { minWidth: 180, minHeight: MINIMIZED_H, allowFreePosition: true } : {});
    var mobileDock =
      isMobile() &&
      !isMinimized &&
      !isMaximized &&
      panel.classList.contains("sens-ai-panel--mobile-dock");
    if (mobileDock) {
      panel.style.left = "";
      panel.style.right = "";
      panel.style.width = "";
      panel.style.maxWidth = "";
      panel.style.top = layout.y + "px";
      panel.style.height = layout.height + "px";
    } else {
      panel.style.left = layout.x + "px";
      panel.style.top = layout.y + "px";
      panel.style.width = layout.width + "px";
      panel.style.height = layout.height + "px";
    }
    if (!isMobile() && !isMaximized && !isMinimized) saveLayout(layout);
  }

  function resetMobilePageZoom() {
    if (!isMobile()) return;
    document.documentElement.scrollLeft = 0;
    document.body.scrollLeft = 0;
    if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  }

  function syncMobileInputFocus() {
    if (!isMobile() || isMinimized) return;
    syncMobileViewport();
    requestAnimationFrame(syncMobileViewport);
  }

  function setMinimized(min) {
    if (min && isMaximized) setMaximized(false);
    isMinimized = min;
    panel.classList.remove("is-minimized");
    panel.setAttribute("aria-hidden", min ? "true" : "false");
    launcher.hidden = !min;
    try {
      localStorage.setItem(STORAGE_MIN, min ? "1" : "0");
    } catch (e) {}
    if (min) {
      if (layout) expandedLayout = layout;
      panel.classList.remove("is-ready");
      if (isCyberLaunchVideoActive()) finishCyberLaunchVideo();
      else dismissCyberLaunchVideo();
    } else {
      panel.classList.add("is-ready");
      applyLayout(isMobile() ? mobileDockLayout() : (expandedLayout || defaultLayout()));
    }
    syncNebulaOrbs();
  }

  function openPanel() {
    setMinimized(false);
    if (!playCyberLaunchVideo()) {
      maybePlayButlerAvatarIntro();
    }
    focusChatInputUnlessLaunchVideo();
  }

  function initPanelPosition() {
    layout = loadLayout();
    expandedLayout = layout;
    applyLayout(layout);
    restoreChatSession();
    ensureChatSessionId();
    ensureBotMessageAvatars();
    setMinimized(loadMinimizedPreference());
    if (!isMinimized && !playCyberLaunchVideo()) {
      maybePlayButlerAvatarIntro();
    }
    scrollMessages();
  }

  function onPointerMove(clientX, clientY) {
    if (dragState) {
      if (isMobile()) {
        endPointer();
        return;
      }
      applyLayout({
        x: dragState.originX + (clientX - dragState.startX),
        y: dragState.originY + (clientY - dragState.startY),
        width: layout.width,
        height: layout.height
      });
      if (!isMinimized) expandedLayout = layout;
    }
    if (resizeState && !isMinimized && !isMobile()) {
      var dx = clientX - resizeState.startX;
      var dy = clientY - resizeState.startY;
      var x = resizeState.originX;
      var y = resizeState.originY;
      var w = resizeState.originW;
      var h = resizeState.originH;
      var handle = resizeState.handle;
      if (handle.indexOf("e") >= 0) w = resizeState.originW + dx;
      if (handle.indexOf("w") >= 0) {
        w = resizeState.originW - dx;
        x = resizeState.originX + dx;
      }
      if (handle.indexOf("s") >= 0) h = resizeState.originH + dy;
      if (handle.indexOf("n") >= 0) {
        h = resizeState.originH - dy;
        y = resizeState.originY + dy;
      }
      var next = clampLayout({ x: x, y: y, width: w, height: h });
      if (handle.indexOf("w") >= 0) next.x = resizeState.originX + resizeState.originW - next.width;
      if (handle.indexOf("n") >= 0) next.y = resizeState.originY + resizeState.originH - next.height;
      applyLayout(next);
      expandedLayout = layout;
    }
  }

  function endPointer(e) {
    if (dragState && headerClickStart && !isMinimized) {
      var clientX = headerClickStart.x;
      var clientY = headerClickStart.y;
      if (e) {
        if (typeof e.clientX === "number") {
          clientX = e.clientX;
          clientY = e.clientY;
        } else if (e.changedTouches && e.changedTouches[0]) {
          clientX = e.changedTouches[0].clientX;
          clientY = e.changedTouches[0].clientY;
        }
      }
      var dx = clientX - headerClickStart.x;
      var dy = clientY - headerClickStart.y;
      if (dx * dx + dy * dy <= HEADER_CLICK_THRESHOLD * HEADER_CLICK_THRESHOLD) {
        setMinimized(true);
      }
    }
    headerClickStart = null;
    if (dragState || resizeState) {
      dragState = null;
      resizeState = null;
      isDragging = false;
      isResizing = false;
      panel.classList.remove("is-dragging", "is-resizing");
      document.body.style.userSelect = "";
    }
  }

  function beginDrag(clientX, clientY) {
    if (isMobile()) return;
    if (isMaximized) setMaximized(false);
    isDragging = true;
    panel.classList.add("is-dragging");
    dragState = {
      startX: clientX,
      startY: clientY,
      originX: layout.x,
      originY: layout.y
    };
    document.body.style.userSelect = "none";
  }

  function beginResize(handle, clientX, clientY) {
    if (isMinimized) return;
    if (isMaximized) setMaximized(false);
    isResizing = true;
    panel.classList.add("is-resizing");
    resizeState = {
      handle: handle,
      startX: clientX,
      startY: clientY,
      originX: layout.x,
      originY: layout.y,
      originW: layout.width,
      originH: layout.height
    };
    document.body.style.userSelect = "none";
  }

  dragHandle.addEventListener("mousedown", function (e) {
    if (e.button !== 0 || isMinimized) return;
    if (e.target.closest(".sens-ai-panel__icon-btn")) return;
    headerClickStart = { x: e.clientX, y: e.clientY };
    e.preventDefault();
    beginDrag(e.clientX, e.clientY);
  });

  dragHandle.addEventListener("touchstart", function (e) {
    if (isMinimized) return;
    if (e.target.closest(".sens-ai-panel__icon-btn")) return;
    var t = e.touches[0];
    if (!t) return;
    headerClickStart = { x: t.clientX, y: t.clientY };
    beginDrag(t.clientX, t.clientY);
  }, { passive: true });

  panel.querySelectorAll("[data-resize]").forEach(function (el) {
    function start(e, clientX, clientY) {
      e.preventDefault();
      e.stopPropagation();
      beginResize(el.getAttribute("data-resize"), clientX, clientY);
    }
    el.addEventListener("mousedown", function (e) {
      if (e.button !== 0) return;
      start(e, e.clientX, e.clientY);
    });
    el.addEventListener("touchstart", function (e) {
      var t = e.touches[0];
      if (!t) return;
      start(e, t.clientX, t.clientY);
    }, { passive: false });
  });

  window.addEventListener("mousemove", function (e) {
    onPointerMove(e.clientX, e.clientY);
  });
  window.addEventListener("mouseup", endPointer);
  window.addEventListener("touchmove", function (e) {
    var t = e.touches[0];
    if (t && (dragState || resizeState)) onPointerMove(t.clientX, t.clientY);
  }, { passive: true });
  window.addEventListener("touchend", endPointer);

  window.addEventListener("resize", function () {
    syncMobileMode();
    if (isMaximized && !isMinimized) {
      applyLayout(maximizeLayout());
      expandedLayout = layout;
      return;
    }
    if (isMobile() && !isMinimized) {
      applyLayout(mobileDockLayout());
      expandedLayout = layout;
    } else if (layout && !isMinimized) {
      applyLayout(layout);
    }
    resizeNebulaOrbs();
  });

  function syncMobileViewport() {
    if (!isMobile() || isMinimized) return;
    if (isMaximized) {
      applyLayout(maximizeLayout());
      expandedLayout = layout;
      return;
    }
    applyLayout(mobileDockLayout());
    expandedLayout = layout;
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", syncMobileViewport);
    window.visualViewport.addEventListener("scroll", syncMobileViewport);
  }

  minimizeBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    setMinimized(true);
  });

  if (maximizeBtn) {
    maximizeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      if (isMinimized) return;
      setMaximized(!isMaximized);
    });
  }

  if (newChatBtn) {
    newChatBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      startNewChat();
    });
  }

  launcher.addEventListener("click", openPanel);

  if (cyberLaunchVideoEl) {
    cyberLaunchVideoEl.addEventListener("ended", function () {
      finishCyberLaunchVideo();
      focusChatInputUnlessLaunchVideo();
    });
    cyberLaunchVideoEl.addEventListener("click", function (event) {
      event.stopPropagation();
      toggleCyberLaunchVideoAudio();
    });
    cyberLaunchVideoEl.addEventListener("contextmenu", function (event) {
      if (!isCyberLaunchVideoActive()) return;
      event.preventDefault();
    });
  }
  if (cyberLaunchOverlayEl) {
    cyberLaunchOverlayEl.addEventListener("contextmenu", function (event) {
      if (!isCyberLaunchVideoActive()) return;
      event.preventDefault();
    });
  }
  if (cyberLaunchSkipEl) {
    cyberLaunchSkipEl.addEventListener("click", function (event) {
      event.stopPropagation();
      skipCyberLaunchVideoToChat();
    });
  }
  document.addEventListener("keydown", function (event) {
    if (!isCyberLaunchVideoActive()) return;
    if (event.key !== "Enter" || event.shiftKey) return;
    event.preventDefault();
    skipCyberLaunchVideoToChat();
  });
  if (cyberLaunchAudioEl && cyberLaunchVideoEl) {
    updateCyberLaunchAudioIndicator();
  }

  function isMiraiUiTarget(target) {
    if (!target || !target.closest) return false;
    if (panel.contains(target)) return true;
    if (launcher.contains(target)) return true;
    if (toastEl && toastEl.contains(target)) return true;
    return false;
  }

  function dismissPanelOnOutsideInteraction(event) {
    if (isMinimized || isDragging || isResizing || dragState || resizeState) return;
    var target = event.target;
    if (!target || isMiraiUiTarget(target)) return;
    setMinimized(true);
    closeAttachMenu();
    if (inputEl && document.activeElement === inputEl) inputEl.blur();
  }

  document.addEventListener("mousedown", dismissPanelOnOutsideInteraction);
  document.addEventListener(
    "touchstart",
    function (event) {
      if (event.touches && event.touches.length > 1) return;
      dismissPanelOnOutsideInteraction(event);
    },
    { passive: true }
  );

  function resetInputHeight() {
    inputEl.style.height = "24px";
  }

  function growInputHeight() {
    inputEl.style.height = "24px";
    inputEl.style.height = Math.min(inputEl.scrollHeight, 180) + "px";
  }

  function decodeHtmlEntities(text) {
    var raw = String(text || "");
    if (!raw.includes("&") && !raw.includes("\u00a0")) {
      return raw;
    }
    var el = document.createElement("textarea");
    var decoded = raw;
    for (var i = 0; i < 3; i++) {
      el.innerHTML = decoded;
      var next = el.value;
      if (next === decoded) break;
      decoded = next;
    }
    return decoded.replace(/\u00a0/g, " ");
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function cleanDisplayText(text) {
    return decodeHtmlEntities(
      String(text || "")
        .replace(/<br\s*\/?>/gi, " · ")
        .replace(/<\/?[^>]+>/g, "")
        .replace(/\s+/g, " ")
        .trim()
    );
  }

  function stripTrailingEllipsis(text) {
    return String(text || "")
      .replace(/(?:…|\.{3,})\s*$/g, "")
      .trim();
  }

  function injectWineTitleLinks(text, wines) {
    if (!wines || !wines.length) return String(text || "");
    var skipLabel =
      /^(?:red|white|wine|wines|port|port wine|porto|紅酒|白酒|波特|波特酒)$/i;
    return String(text || "").replace(/\*\*([^*]{3,180})\*\*/g, function (match, name) {
      var trimmed = String(name || "").replace(/\s+/g, " ").trim();
      if (!trimmed || skipLabel.test(trimmed)) return match;
      if (/\]\([^)]+\)/.test(trimmed)) return match;
      var wine = findWineForName(trimmed, wines);
      if (!wine) return match;
      var url = wineProductUrl(wine);
      if (!url || url === "#") return match;
      return "[" + trimmed + "](" + url + ")";
    });
  }

  function stripOrphanProductUrls(text) {
    return String(text || "").replace(
      /(\[[^\]]+\]\([^)]+\))\s+\((?:https?:\/\/[^)\s]*\/products\/[^)\s]+|\/products\/[^)\s]+)\)/gi,
      "$1"
    );
  }

  function normalizeWineMarkdownLinks(text, wines) {
    var source = repairWineMarkdownSyntax(decodeHtmlEntities(String(text || "")));
    if (!wines || !wines.length) return stripOrphanProductUrls(source);

    source = stripOrphanProductUrls(source);

    source = source.replace(
      /\[([^\]]{3,220})\]\((https?:\/\/[^)\s]+|\/products\/[^)\s]+)\)/gi,
      function (match, title, url) {
        var wine = findWineForName(cleanDisplayText(title), wines);
        if (!wine) return match;
        var canonical = wineProductUrl(wine);
        if (!canonical || canonical === "#") return match;
        var safeTitle = cleanDisplayText(title).replace(/[\[\]]/g, "").trim();
        return buildWineMarkdownLink(safeTitle, canonical);
      }
    );

    source = source.replace(
      /\[([^\]]{3,220})\]\((https?:\/\/[^\s)]*)$/gim,
      function (match, title) {
        var wine = findWineForName(cleanDisplayText(title), wines);
        if (!wine) {
          return "**" + cleanDisplayText(title).replace(/[\[\]]/g, "").trim() + "**";
        }
        var canonical = wineProductUrl(wine);
        if (!canonical || canonical === "#") {
          return "**" + cleanDisplayText(title).replace(/[\[\]]/g, "").trim() + "**";
        }
        var safeTitle = cleanDisplayText(title).replace(/[\[\]]/g, "").trim();
        return buildWineMarkdownLink(safeTitle, canonical);
      }
    );

    source = source.replace(
      /\[([^\]]{3,220})\]\((https?:\/\/[^)]+)\)/gi,
      function (match, title, url) {
        if (isValidShopifyProductUrl(url)) return match;
        var wine = findWineForName(cleanDisplayText(title), wines);
        if (!wine) return match;
        var canonical = wineProductUrl(wine);
        if (!canonical || canonical === "#") return match;
        var safeTitle = cleanDisplayText(title).replace(/[\[\]]/g, "").trim();
        return buildWineMarkdownLink(safeTitle, canonical);
      }
    );

    return stripOrphanProductUrls(source);
  }

  function renderMarkdownLinks(text) {
    var source = String(text || "");
    source = source.replace(
      /\[([^\]]+)\]\((https?:\/\/[^)\s]*\/products\/[a-z0-9][a-z0-9-]*|\/products\/[a-z0-9][a-z0-9-]*)(?:\?[^)\s]*)?\)/gi,
      function (_m, label, href) {
        var cleanHref = String(href || "").split("?")[0];
        if (cleanHref.charAt(0) === "/") {
          cleanHref = storefrontRoot() + cleanHref;
        }
        return (
          '<a class="sens-ai-msg__wine-link" href="' +
          escapeHtml(cleanHref) +
          '" target="_blank" rel="noopener noreferrer">' +
          label +
          "</a>"
        );
      }
    );
    source = source.replace(
      /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/gi,
      function (_m, label, href) {
        if (/\/products\//i.test(href)) return _m;
        return (
          '<a class="sens-ai-msg__link" href="' +
          escapeHtml(href) +
          '" target="_blank" rel="noopener noreferrer">' +
          label +
          "</a>"
        );
      }
    );
    return source;
  }

  function formatReply(text, wines) {
    var cleaned = decodeHtmlEntities(String(text || ""))
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/?[^>]+>/g, "");
    if (wines && wines.length) {
      cleaned = normalizeWineMarkdownLinks(cleaned, wines);
    } else {
      cleaned = stripOrphanProductUrls(cleaned);
    }
    var safe = escapeHtml(cleaned);
    safe = renderMarkdownLinks(safe);
    safe = safe.replace(
      /(<a class="sens-ai-msg__wine-link"[^>]*>[^<]+<\/a>)\s*\((?:https?:\/\/[^)\s]*\/products\/[^)\s]+|\/products\/[^)\s]+)\)/gi,
      "$1"
    );
    safe = safe.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    safe = safe.replace(/\n/g, "<br>");
    // Fallback spacing when numbered picks lost their paragraph breaks upstream.
    safe = safe.replace(/(<br>)?(\d+\.\s)(?=<)/g, function (_m, priorBr, num) {
      return priorBr ? "<br>" + num : "<br><br>" + num;
    });
    return safe;
  }

  var LOADING_MESSAGE = "Mirai is thinking…";
  var READ_MORE_LABEL = "Read more";
  var READ_MORE_LABEL_LESS = "Show less";
  var READ_MORE_SKIP_REPLY_RE = [
    /^Finding wines for you/i,
    /^Thinking/i,
    /^Just a moment/i,
    /^One moment/i,
    /^Sorry, something went wrong/i,
    /couldn't find/i,
    /could not find/i,
    /no specific wine/i,
    /checked our current selection/i,
    /^暫時未/i,
    /^今次未/i,
    /^現在、ご希望/i,
    /^今回のご希望/i,
  ];

  function buildCardReadMoreHtml(url, previewText, fullText) {
    var preview = String(previewText || "").trim();
    var full = String(fullText || preview).trim();
    var linkOpen =
      url && url !== "#"
        ? '<a class="sens-ai-wine-comments-link" href="' + escapeHtml(url) + '">'
        : "";
    var linkClose = url && url !== "#" ? "</a>" : "";
    var labelHtml = '<p class="sens-ai-wine-notes-label">Comments:</p>';
    return (
      '<div class="sens-ai-read-more sens-ai-read-more--card" data-read-more data-read-more-preview="' +
      escapeHtml(preview) +
      '" data-read-more-full="' +
      escapeHtml(full) +
      '">' +
      linkOpen +
      labelHtml +
      '<div class="sens-ai-read-more__content">' +
      escapeHtml(preview) +
      "</div>" +
      linkClose +
      '<button type="button" class="sens-ai-read-more__btn" aria-expanded="false">' +
      escapeHtml(READ_MORE_LABEL) +
      "</button></div>"
    );
  }

  function buildWineCardCommentsHtml(url, preview, full) {
    var cardNotes = pickNotesDisplayText(preview, full);
    var linkOpen =
      url && url !== "#"
        ? '<a class="sens-ai-wine-comments-link" href="' + escapeHtml(url) + '">'
        : "";
    var linkClose = url && url !== "#" ? "</a>" : "";
    var labelHtml = '<p class="sens-ai-wine-notes-label">Comments:</p>';
    if (shouldUseReadMoreCard(preview, full)) {
      return buildCardReadMoreHtml(url, preview, full);
    }
    return linkOpen + labelHtml + '<p class="sens-ai-wine-reason">' + escapeHtml(cardNotes) + "</p>" + linkClose;
  }

  function buildReadMoreHtml(previewText, extraClass, fullText, previewHtml, wines) {
    var preview = String(previewText || "").trim();
    var full = String(fullText || preview).trim();
    var cls = "sens-ai-read-more" + (extraClass ? " " + extraClass : "");
    var inner = previewHtml != null ? previewHtml : escapeHtml(preview);
    var wineAttr = "";
    if (wines && wines.length) {
      try {
        wineAttr = escapeHtml(JSON.stringify(wines));
      } catch (e) {
        wineAttr = "";
      }
    }
    return (
      '<div class="' +
      cls +
      '" data-read-more data-read-more-preview="' +
      escapeHtml(preview) +
      '" data-read-more-full="' +
      escapeHtml(full) +
      '"' +
      (wineAttr ? ' data-read-more-wines="' + wineAttr + '"' : "") +
      ">" +
      '<div class="sens-ai-read-more__content">' +
      inner +
      "</div>" +
      '<button type="button" class="sens-ai-read-more__btn" aria-expanded="false">' +
      escapeHtml(READ_MORE_LABEL) +
      "</button></div>"
    );
  }

  function textLooksTruncated(text) {
    return /(?:…|\.{3,})\s*$/.test(String(text || "").trim());
  }

  function canExpandReadMore(previewText, fullText, minCssLength) {
    var preview = String(previewText || "").trim();
    var full = String(fullText || preview).trim();
    if (!preview) return false;
    var previewStem = stripTrailingEllipsis(preview);
    var fullStem = stripTrailingEllipsis(full);
    if (full.length > preview.length + 8) return true;
    if (fullStem.length > previewStem.length + 8) return true;
    if (textLooksTruncated(preview) && !textLooksTruncated(full)) return true;
    if (textLooksTruncated(preview) && previewStem === fullStem) return false;
    if (!textLooksTruncated(preview) && preview.length >= minCssLength) return true;
    return false;
  }

  function isReadMoreExcludedReply(text) {
    var t = String(text || "").trim();
    for (var i = 0; i < READ_MORE_SKIP_REPLY_RE.length; i++) {
      if (READ_MORE_SKIP_REPLY_RE[i].test(t)) return true;
    }
    return false;
  }

  function readMoreUiEnabled() {
    return chatTheme === "modern";
  }

  function shouldUseReadMoreReply(previewText, fullText) {
    if (!readMoreUiEnabled()) return false;
    if (isReadMoreExcludedReply(previewText)) return false;
    return canExpandReadMore(previewText, fullText, 360);
  }

  function shouldUseReadMoreCard(previewText, fullText) {
    if (!readMoreUiEnabled()) return false;
    return canExpandReadMore(previewText, fullText, 120);
  }

  function pickNotesDisplayText(preview, full) {
    if (readMoreUiEnabled()) return preview;
    return String(full || preview || "").trim();
  }

  function isCatalogIntroBlock(block) {
    var text = String(block || "").trim();
    if (!/\*\*[^*]+\*\*/.test(text)) return false;
    return (
      /Here are \*\*|Here(?:'s| is) what we have in \*\*|options under HK\$|from the SENS cellar|SENS cellar/i.test(
        text
      )
    );
  }

  function isMusicVideoCatalogQuery(message) {
    var text = String(message || "").trim();
    if (!text) return false;
    return (
      /\bmusic\s+(?:pairing|pair(?:ed|s)?|video|embed)\b/i.test(text) ||
      /\b(?:wine|wines|bottle|bottles)\s+(?:with|and|\+)\s+music\b/i.test(text) ||
      /\bmusic\s+(?:with|and|\+)\s+(?:wine|wines)\b/i.test(text) ||
      /\b(?:youtube|vimeo)\s+(?:video|wine|pairing)?\b/i.test(text) ||
      /音樂配酒|有音樂|音樂視頻|音樂影片/.test(text) ||
      /^(?:show\s+me|find\s+me|list|browse|see)\b.*\b(?:wine|wines|bottle|bottles)\b.*\bmusic\b/i.test(
        text
      )
    );
  }

  function resolveMaxWineResults(mode, message) {
    if (mode === "music_video_catalog" || isMusicVideoCatalogQuery(message)) {
      return CONFIG.maxMusicVideoResults;
    }
    return CONFIG.maxWineResults;
  }

  function isFreshCatalogSearch(message) {
    var text = String(message || "").trim();
    if (!text) return false;
    return /^(?:do you have|have you got|got any|any|looking for|searching for|show me|find me)\b/i.test(
      text
    );
  }

  function extractCatalogSearchSubject(message) {
    var text = String(message || "").trim();
    var patterns = [
      /^(?:do you have|have you got|got any|any|looking for|searching for|show me|find me)\s+(.+?)\??$/i,
    ];
    for (var i = 0; i < patterns.length; i++) {
      var match = text.match(patterns[i]);
      if (!match || !match[1]) continue;
      return match[1]
        .replace(/\b(?:wine|wines|in stock|available)\b/gi, " ")
        .replace(/\s+/g, " ")
        .trim();
    }
    return "";
  }

  var CATALOG_SUBJECT_SYNONYMS = {
    beaujolais: [
      "beaujolais",
      "gamay",
      "morgon",
      "fleurie",
      "moulin",
      "brouilly",
      "julienas",
      "chenas",
      "chiroubles",
      "regnie",
      "saint amour",
    ],
    burgundy: ["burgundy", "bourgogne", "pinot noir", "chardonnay", "chablis", "meursault"],
    bordeaux: ["bordeaux", "pauillac", "margaux", "saint emilion", "pomerol", "medoc"],
    chablis: ["chablis"],
    rioja: ["rioja"],
    mediterranean: [
      "mediterranean",
      "languedoc",
      "alella",
      "bulgaria",
      "bessa valley",
      "enira",
      "hortus",
      "corbieres",
      "minervois",
      "pic saint loup",
      "provence",
      "priorat",
    ],
    barolo: ["barolo", "nebbiolo"],
    "non alc": [
      "non alcohol",
      "non alcohol wine",
      "non alcohol wines",
      "non alcoholic",
      "non alcoholic wine",
      "non alcoholic wines",
      "non-alcoholic",
      "alcohol free",
      "zero alcohol",
      "pierre zero",
      "pierre zero signature",
      "signature grenache",
      "signature chardonnay",
      "sparkling tea",
      "dealcoholized",
      "de alcoholised",
      "0 abv",
      "零酒精",
      "無酒精",
    ],
  };

  var NON_ALCOHOLIC_SUBJECT_RE =
    /\b(?:non[- ]?alcohol(?:ic)?(?:\s+wines?|\s+beverages?)?|non[- ]?alc(?:ohol(?:ic)?)?|no[- ]?alc(?:ohol(?:ic)?)?|zero[- ]?alc(?:ohol(?:ic)?)?|alcohol[- ]?free(?:\s+wines?)?|dealcoholi[zs]ed|de[- ]?alcoholi[zs]ed|0%\s*abv|零酒精|無酒精)\b/i;

  function isNonAlcoholicSubject(subject) {
    return NON_ALCOHOLIC_SUBJECT_RE.test(String(subject || ""));
  }

  function isNonAlcoholicWine(wine) {
    var hay = wineCatalogHaystack(wine);
    if (!hay) return false;
    return (
      /\b(?:non[- ]?alcohol(?:ic)?|alcohol[- ]?free|zero alcohol|0 abv|pierre\s*z[eéèë]?ro|sparkling tea|dealcoholi|desalcohol|sans alcool|signature|零酒精|無酒精|高階系列)\b/i.test(
        hay
      ) || hay.indexOf("non alcoholic") >= 0
    );
  }

  function isNonAlcoholicCatalogQuery(message) {
    return isNonAlcoholicSubject(String(message || ""));
  }

  function catalogSubjectTerms(subject) {
    var key = normalizeTitleKey(subject);
    if (!key) return [];
    if (isNonAlcoholicSubject(subject)) {
      return CATALOG_SUBJECT_SYNONYMS["non alc"].slice();
    }
    if (CATALOG_SUBJECT_SYNONYMS[key]) {
      return CATALOG_SUBJECT_SYNONYMS[key].slice();
    }
    for (var alias in CATALOG_SUBJECT_SYNONYMS) {
      if (key.indexOf(alias) >= 0 || alias.indexOf(key) >= 0) {
        return CATALOG_SUBJECT_SYNONYMS[alias].slice();
      }
    }
    return [key];
  }

  function wineCatalogHaystack(wine) {
    return normalizeTitleKey(
      [
        wine && wine.title,
        wine && wine.product_type,
        wine && wine.variant_title,
        wine && wine.match_reason,
        wine && wine.pairing_reason,
        wine && wine.tasting_notes,
        wine && wine.tasting_notes_full,
        wine && wine.handle,
      ]
        .filter(Boolean)
        .join(" ")
    );
  }

  function wineMatchesCatalogSubject(wine, subject) {
    var terms = catalogSubjectTerms(subject);
    if (!terms.length) return true;
    var hay = wineCatalogHaystack(wine);
    if (!hay) return false;
    return terms.some(function (term) {
      return hay.indexOf(normalizeTitleKey(term)) >= 0;
    });
  }

  function filterWinesForCatalogSubject(wines, userMessage, mode) {
    if (!wines || !wines.length) return wines || [];
    if (mode === "music_video_catalog" || isMusicVideoCatalogQuery(userMessage)) {
      return wines;
    }
    if (isNonAlcoholicSubject(userMessage)) {
      return wines.filter(isNonAlcoholicWine);
    }
    if (!isFreshCatalogSearch(userMessage)) return wines;
    var subject = extractCatalogSearchSubject(userMessage);
    if (!subject || subject.length < 3) return wines;
    if (isNonAlcoholicSubject(subject)) {
      return wines.filter(isNonAlcoholicWine);
    }
    var filtered = wines.filter(function (wine) {
      return wineMatchesCatalogSubject(wine, subject);
    });
    return filtered.length ? filtered : wines;
  }

  function wineColorHint(title) {
    var key = normalizeTitleKey(title);
    if (/\bblanc\b|\bwhite\b|白酒/.test(key)) return "white";
    if (/\brouge\b|\bred\b|紅酒|红酒/.test(key)) return "red";
    return "";
  }

  function introSubjectMatchesReplyWines(subject, replyWines, allWines) {
    var subjectText = String(subject || "").trim();
    if (!subjectText) return false;
    var wines = replyWines && replyWines.length ? replyWines : allWines;
    if (!wines || !wines.length) return false;
    if (findWineForName(subjectText, wines)) return true;
    var subjectColor = wineColorHint(subjectText);
    var matched = wines.filter(function (wine) {
      return scoreWineTitleMatch(wine.title, subjectText) >= 500;
    });
    if (!matched.length) return false;
    if (subjectColor && wines.length === 1) {
      var pickColor = wineColorHint(wines[0].title);
      if (pickColor && subjectColor !== pickColor) return false;
    }
    if (subjectColor && matched.length === 1) {
      var onlyColor = wineColorHint(matched[0].title);
      if (onlyColor && subjectColor !== onlyColor) return false;
    }
    return matched.length > 0;
  }

  function formatCatalogIntroLabel(wines, userMessage) {
    if (!wines || !wines.length) return "";
    if (wines.length === 1) return cleanDisplayText(wines[0].title);
    var subject = extractCatalogSearchSubject(userMessage);
    var subjectKey = normalizeTitleKey(subject);
    if (
      subjectKey &&
      wines.every(function (wine) {
        return normalizeTitleKey(wine.title).indexOf(subjectKey) >= 0;
      })
    ) {
      return subject.replace(/\b[a-z]/g, function (ch, idx, all) {
        var prev = all.charAt(idx - 1);
        return !prev || /\s/.test(prev) ? ch.toUpperCase() : ch;
      });
    }
    if (wines.length === 2) {
      return (
        cleanDisplayText(wines[0].title) +
        "** and **" +
        cleanDisplayText(wines[1].title)
      );
    }
    return wines
      .slice(0, 3)
      .map(function (wine) {
        return cleanDisplayText(wine.title);
      })
      .join(", ");
  }

  function realignCatalogIntroInReply(reply, wines, userMessage) {
    var source = String(reply || "");
    if (!source.trim() || !wines || !wines.length) return source;
    var blocks = source.split(/\n{2,}/);
    var introRe =
      /^(Here(?:'s| is) what we have in )\*\*([^*]+)\*\*((?:\s+on SENS)?[：:].*)$/i;
    var changed = false;
    var replyWines = filterWinesMatchingReply(source, wines);
    var maxResults = resolveMaxWineResults("", userMessage);
    var introWines = wines.slice(0, maxResults);
    if (replyWines.length) introWines = replyWines;
    else if (wines.length > introWines.length) introWines = wines.slice(0, maxResults);

    blocks = blocks.map(function (block) {
      var trimmed = String(block || "").trim();
      var match = trimmed.match(introRe);
      if (!match) return block;
      var introSubject = cleanDisplayText(match[2]);
      if (introSubjectMatchesReplyWines(introSubject, introWines, wines)) return block;
      var label = formatCatalogIntroLabel(introWines, userMessage);
      if (!label) return block;
      changed = true;
      return match[1] + "**" + label + "**" + match[3];
    });
    return changed ? blocks.join("\n\n") : source;
  }

  function extractMarkdownLinkWineNames(text) {
    var names = [];
    var re = /\[([^\]]{6,220})\]\((?:https?:\/\/[^)]+)?\/products\/[^)]+\)/gi;
    var match;
    while ((match = re.exec(String(text || ""))) !== null) {
      var name = cleanDisplayText(match[1]);
      if (name && !/^(?:red|white|wine|wines)$/i.test(name)) names.push(name);
    }
    return names;
  }

  function extractBoldWineNames(text) {
    var names = [];
    var re = /\*\*([^*]{3,140})\*\*/g;
    var match;
    while ((match = re.exec(String(text || ""))) !== null) {
      var name = cleanDisplayText(match[1].replace(/\s+/g, " ").trim());
      if (!name || /^(?:red|white|wine|wines|紅酒|白酒)$/i.test(name)) continue;
      if (/^wines?\s+(?:of|from|under|around|about)/i.test(name)) continue;
      if (/options under/i.test(name)) continue;
      if (isMalformedBudgetAnchor(name)) continue;
      if (/^budget\s+below\s+\d/i.test(name)) continue;
      names.push(name);
    }
    extractMarkdownLinkWineNames(text).forEach(function (linked) {
      if (names.indexOf(linked) < 0) names.push(linked);
    });
    return names;
  }

  function normalizeTitleKey(title) {
    return String(title || "")
      .toLowerCase()
      .replace(/[^a-z0-9\u4e00-\u9fff]+/gi, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function stripCriticRatingFromTitle(title) {
    return String(title || "")
      .replace(
        /\s*\((?:Robert Parker(?:'s)?|RP\s*:|James Suckling(?:'s)?|JS\s*:|Wine Enthusiast(?:'s)?|WE\s*:)[^)]*\)\s*/gi,
        " "
      )
      .replace(/\s+/g, " ")
      .trim();
  }

  function isValidShopifyProductUrl(url) {
    var path = String(url || "")
      .split("?")[0]
      .split("#")[0]
      .replace(/^https?:\/\/[^/]+/i, "");
    return /^\/products\/[a-z0-9][a-z0-9-]*$/i.test(path);
  }

  function repairWineMarkdownSyntax(text) {
    return String(text || "")
      .replace(/\]\s*\n\s*\(/g, "](")
      .replace(/\]\s+\((https?:\/\/)/gi, "]($1");
  }

  function buildWineMarkdownLink(title, url) {
    var safeTitle = cleanDisplayText(title).replace(/[\[\]]/g, "").trim();
    var cleanUrl = String(url || "").trim();
    if (!safeTitle || !cleanUrl || cleanUrl === "#") return safeTitle || "";
    return "[" + safeTitle + "](" + cleanUrl + ")";
  }

  function titleMatchesCandidate(wineTitle, candidate) {
    return scoreWineTitleMatch(wineTitle, candidate) >= 500;
  }

  function scoreWineTitleMatch(wineTitle, candidate) {
    var a = normalizeTitleKey(wineTitle);
    var b = normalizeTitleKey(candidate);
    if (!a || !b) return 0;
    if (a === b) return 10000;
    if (a.indexOf(b) >= 0) return 8000 + b.length;
    if (b.indexOf(a) >= 0) return 7000 + a.length;
    var stopWords = {
      mosel: 1,
      riesling: 1,
      weingut: 1,
      wine: 1,
      immich: 1,
      batterieberg: 1,
      organic: 1,
      reserve: 1,
    };
    var words = a.split(" ").filter(function (w) {
      return (w.length > 2 || /^\d{4}$/.test(w)) && !stopWords[w];
    });
    if (!words.length) return 0;
    var hits = 0;
    var yearHit = false;
    for (var i = 0; i < words.length; i++) {
      if (/^\d{4}$/.test(words[i])) {
        if (b.indexOf(words[i]) >= 0) {
          yearHit = true;
          hits += 4;
        }
        continue;
      }
      if (b.indexOf(words[i]) >= 0) {
        hits += words[i].length > 6 ? 3 : 2;
      }
    }
    if (yearHit && hits >= 4) return 2500 + hits;
    if (hits >= 4) return 1200 + hits;
    if (hits >= 3) return 800 + hits;
    return 0;
  }

  function findBestWineForBlock(names, wines, seenTitles) {
    var bestWine = null;
    var bestScore = 0;
    for (var ni = 0; ni < names.length; ni++) {
      for (var wi = 0; wi < wines.length; wi++) {
        var wine = wines[wi];
        if (seenTitles[wine.title]) continue;
        var score = scoreWineTitleMatch(wine.title, names[ni]);
        if (score > bestScore) {
          bestScore = score;
          bestWine = wine;
        }
      }
    }
    return bestScore >= 500 ? bestWine : null;
  }

  function findWineForName(name, wines) {
    if (!wines || !wines.length) return null;
    var candidates = [String(name || "").trim()];
    var stripped = stripCriticRatingFromTitle(candidates[0]);
    if (stripped && stripped !== candidates[0]) candidates.push(stripped);
    for (var ci = 0; ci < candidates.length; ci++) {
      for (var i = 0; i < wines.length; i++) {
        if (titleMatchesCandidate(wines[i].title, candidates[ci])) return wines[i];
      }
    }
    return null;
  }

  function isWineToFoodIntroBlock(block) {
    return /你問|You asked|what to pair with|可以配什么|に合う料理/i.test(block);
  }

  function isPairingTheoryBlock(block) {
    return (
      /With that in mind, these SENS bottles stand out/i.test(block) ||
      /With that in mind, these bottles stand out/i.test(block) ||
      /I'll search the cellar for/i.test(block) ||
      /classic pairings include bold reds/i.test(block) ||
      /在這個基礎上，SENS 酒窖/i.test(block) ||
      /我會跟返.*方向喺 SENS 酒窖/i.test(block) ||
      /I start with wine traits/i.test(block) ||
      /我會先從菜式需要嘅酒質入手/i.test(block) ||
      /我會先從菜式同酒質入手/i.test(block) ||
      /根據呢個諗法/i.test(block) ||
      /如果根據呢個路線/i.test(block) ||
      /sweetness is the key — the wine should be as sweet or sweeter/i.test(block) ||
      /甜度係關鍵 — 酒應同甜品一樣甜或更甜/i.test(block)
    );
  }

  function dedupeContradictoryPairingTheory(reply) {
    var text = String(reply || "").trim();
    if (!text) return text;
    var blocks = text.split(/\n{2,}/).map(function (block) {
      return block.trim();
    }).filter(Boolean);
    if (blocks.length < 2) return text;

    var first = blocks[0];
    var firstLooksLikePairingFact =
      /\*\*[^*]+\*\*/.test(first) &&
      /(?:pair|配|襯|match|weight|tannin|acid|cream|butter|oyster|lobster|steak|curry|dessert|chardonnay|chablis|riesling|barolo|burgundy)/i.test(
        first
      );

    if (!firstLooksLikePairingFact) return text;

    var kept = [first];
    for (var i = 1; i < blocks.length; i++) {
      if (isPairingTheoryBlock(blocks[i])) continue;
      kept.push(blocks[i]);
    }
    return kept.length >= 2 ? kept.join("\n\n") : text;
  }

  function isLikelyWinePickBlock(block) {
    var text = String(block || "").trim();
    if (isCatalogIntroBlock(block)) return false;
    if (!/\*\*[^*]+\*\*/.test(text) && !/\[[^\]]+\]\([^)]*\/products\//.test(text)) return false;
    if (isWineToFoodIntroBlock(block)) return false;
    if (isPairingTheoryBlock(block)) return false;
    if (/^\d+[\.、．]\s/.test(text)) return true;
    if (/(?:HK)?\$|HKD|（\s*HK| at HK/i.test(text)) return true;
    if (
      /^(?:First|Next|Another option|For red|For white|首先|第二支|另外|第三支|第四支|第五支|第六支|第七支|第八支|其次|最後|接著|其二|其三|紅酒方面|白酒我會揀)/im.test(
        text
      )
    ) {
      return true;
    }
    return false;
  }

  function pickBlockSortKey(block) {
    var match = String(block || "").match(/^\s*(\d+)[\.、．]/);
    if (!match) return 9999;
    var num = parseInt(match[1], 10);
    return Number.isFinite(num) ? num : 9999;
  }

  function partitionReplyBlocks(blocks) {
    var introBlocks = [];
    var pickBlocks = [];
    var outroBlocks = [];
    var seenPick = false;
    (blocks || []).forEach(function (block) {
      if (isLikelyWinePickBlock(block)) {
        pickBlocks.push(block);
        seenPick = true;
        return;
      }
      if (seenPick) outroBlocks.push(block);
      else introBlocks.push(block);
    });
    pickBlocks.sort(function (a, b) {
      var diff = pickBlockSortKey(a) - pickBlockSortKey(b);
      return diff !== 0 ? diff : 0;
    });
    return { introBlocks: introBlocks, pickBlocks: pickBlocks, outroBlocks: outroBlocks };
  }

  function isGenericPairingAdviceComment(text) {
    var cleaned = String(text || "").trim();
    if (!cleaned) return false;
    return (
      /With that in mind, these SENS bottles stand out/i.test(cleaned) ||
      /在這個基礎上，SENS 酒窖/i.test(cleaned) ||
      /I start with wine traits/i.test(cleaned) ||
      /我會先從菜式需要嘅酒質入手/i.test(cleaned) ||
      /我會先從菜式同酒質入手/i.test(cleaned) ||
      /In practice:\s*\*\*/i.test(cleaned) ||
      /按呢個思路：/i.test(cleaned) ||
      (/\*\*(?:Pinot Grigio|Vermentino|Albariño|Chablis|Chianti|Barolo)\*\*/i.test(cleaned) &&
        !/HK\$|HKD| at HK/i.test(cleaned))
    );
  }

  function isProvenanceOnlyComment(text) {
    var cleaned = String(text || "").trim();
    if (!cleaned) return false;
    return (
      /^from\s+.+(?:\s*[·•]\s*)?(?:\d{4}\s*)?vintage\s*[—–-]\s*drinking well now\.?$/i.test(cleaned) ||
      /^from\s+.+\s*[—–-]\s*drinking well now\.?$/i.test(cleaned) ||
      /^產區係\s+.+(?:，已進入適飲期)?。?$/u.test(cleaned)
    );
  }

  function isBudgetOnlyComment(text) {
    var cleaned = String(text || "").trim();
    if (!cleaned) return false;
    if (!/within your budget|fits your search|matches your search|在你預算|風格貼合今次搜尋|符合你今次搜尋/i.test(cleaned)) {
      return false;
    }
    var stripped = cleaned
      .replace(/\bat\s+(?:HK)?\$[\d,]+/gi, "")
      .replace(/(?:HK)?\$[\d,]+/gi, "")
      .replace(/HKD\s*[\d,]+/gi, "")
      .replace(/within your budget and fits your search\.?/gi, "")
      .replace(/within your budget\.?/gi, "")
      .replace(/fits your search\.?/gi, "")
      .replace(/matches your search\.?/gi, "")
      .replace(/在你預算之內[，,]?/g, "")
      .replace(/風格貼合今次搜尋\.?/g, "")
      .replace(/符合你今次搜尋[^。]*\.?/g, "")
      .replace(/^[,，。.!！?\s—–-]+|[,，。.!！?\s—–-]+$/g, "")
      .trim();
    return stripped.length < 16;
  }

  function stripProvenanceTail(text) {
    return String(text || "")
      .replace(/\s+from\s+[^.]+?\s*[—–-]\s*drinking well now\.?\s*$/i, "")
      .replace(/\s+產區係\s+[^。]+?(?:，已進入適飲期)?。?\s*$/u, "")
      .trim();
  }

  function formatBudgetAmount(numStr) {
    var n = parseInt(String(numStr || "").replace(/,/g, ""), 10);
    if (!Number.isFinite(n)) return String(numStr || "").trim();
    return "HK$" + n.toLocaleString("en-US");
  }

  function isMalformedBudgetAnchor(text) {
    var cleaned = cleanDisplayText(text);
    if (!cleaned) return false;
    return /^(?:it\s+(?:with|fits)\s+)?budget\s+below\s+\d/i.test(cleaned);
  }

  function stripMalformedBudgetPhrases(text) {
    var s = String(text || "");
    s = s.replace(
      /\bin\s+it\s+(?:with|fits)\s+budget\s+below\s*(\d[\d,]*)/gi,
      function (_match, amount) {
        return " within your budget (below " + formatBudgetAmount(amount) + ")";
      }
    );
    s = s.replace(
      /\*\*it\s+(?:with|fits)\s+budget\s+below\s*(\d[\d,]*)\*\*/gi,
      function (_match, amount) {
        return "your budget below " + formatBudgetAmount(amount);
      }
    );
    s = s.replace(
      /\bit\s+(?:with|fits)\s+budget\s+below\s*(\d[\d,]*)/gi,
      function (_match, amount) {
        return "your budget below " + formatBudgetAmount(amount);
      }
    );
    s = s.replace(/For\s+your\s+budget\s+below/gi, "With a budget below");
    // Collapse horizontal whitespace only — keep paragraph breaks intact.
    s = s.replace(/[^\S\n]+/g, " ");
    s = s.replace(/\n{3,}/g, "\n\n");
    return s.trim();
  }

  function stripWineMarkdownFromComment(text, wineTitle) {
    var s = String(text || "").trim();
    if (!s) return "";

    var pickMatch = s.match(/^\d+\.\s*(.+)$/);
    if (pickMatch) s = pickMatch[1].trim();

    var dashSplit = s.match(/^(.+?)\s*[—–]\s*(.+)$/);
    if (!dashSplit) dashSplit = s.match(/^(.+?)\s+-\s+(.+)$/);
    if (dashSplit) {
      var head = dashSplit[1].trim();
      var tail = dashSplit[2].trim();
      if (
        /\[[^\]]+\]\([^)]+\)/.test(head) ||
        /https?:\/\/[^\s)]+\/products\//i.test(head) ||
        /\/products\/[^\s)]+/i.test(head)
      ) {
        s = tail;
      } else if (tail.length >= 8) {
        s = tail;
      }
    }

    s = s.replace(/\[[^\]]*\]\([^)]*\)/g, " ");
    s = s.replace(/https?:\/\/[^\s)]+\/products\/[^\s)]+/gi, " ");
    s = s.replace(/\s*\(\s*https?:\/\/[^\s)]+\/products\/[^\s)]+\s*\)/gi, " ");
    s = s.replace(/^\d+\.\s*/, "");

    if (wineTitle) {
      s = s.replace(/\*\*([^*]+)\*\*/g, function (_match, inner) {
        return titleMatchesCandidate(wineTitle, inner) ? "" : inner;
      });
    } else {
      s = s.replace(/\*\*([^*]+)\*\*/g, "$1");
    }

    s = stripMalformedBudgetPhrases(s);
    return cleanDisplayText(s);
  }

  function sanitizeMiraiReplyText(reply) {
    return stripMalformedBudgetPhrases(dedupeContradictoryPairingTheory(reply));
  }

  function cleanWineReplyComment(block, wineTitle) {
    var text = stripWineMarkdownFromComment(block, wineTitle);
    text = text.replace(/[（(]\s*(?:HK)?\$[\d,]+[^）)]*[）)]/gi, " ");
    text = text.replace(/[（(]\s*HKD\s*[\d,]+[^）)]*[）)]/gi, " ");
    text = text.replace(/\bat\s+(?:HK)?\$[\d,]+/gi, " ");
    text = text.replace(
      /^(?:First|Next|Another option|For red[^,—–-]*[,—–-]|For white[^,—–-]*[,—–-]|首先[，,]?|第二支[，,]?|另外[，,]?|第三支[，,]?|第四支[，,]?|其次[，,]?|最後[，,]?|接著[，,]?|其二[，,]?|其三[，,]?|紅酒方面[，,][^，,—–-]*[，,—–-]?|白酒我會揀)\s*/i,
      ""
    );
    text = text.replace(/^[—–\-:，,。\s]+/, "").replace(/\s+/g, " ").trim();
    text = stripProvenanceTail(text);
    return stripMalformedBudgetPhrases(text);
  }

  function countNumberedPicks(reply) {
    return (String(reply || "").match(/^\s*\d+[\.、．]\s+/gm) || []).length;
  }

  function filterWinesMatchingReply(reply, wines) {
    if (!wines || !wines.length) return [];
    var cleanedReply = sanitizeMiraiReplyText(reply);
    var blocks = String(cleanedReply || "")
      .split(/\n{2,}/)
      .map(function (block) {
        return block.trim();
      })
      .filter(Boolean);
    var matched = [];
    var seenTitles = {};
    blocks.forEach(function (block) {
      if (!isLikelyWinePickBlock(block)) return;
      var names = extractBoldWineNames(block);
      if (!names.length) return;
      var pick = findBestWineForBlock(names, wines, seenTitles);
      if (!pick) return;
      matched.push(pick);
      seenTitles[pick.title] = true;
    });
    return matched;
  }

  function cardWinesFromApiResponse(reply, wines, userMessage, mode) {
    if (!wines || !wines.length) return [];
    var maxResults = resolveMaxWineResults(mode, userMessage);
    if (mode === "music_video_catalog" || isMusicVideoCatalogQuery(userMessage)) {
      return wines.slice(0, maxResults);
    }
    var scopedWines = filterWinesForCatalogSubject(wines, userMessage, mode);
    var apiWines = scopedWines.slice(0, maxResults);
    if (isNonAlcoholicCatalogQuery(userMessage)) {
      return apiWines;
    }
    var numbered = countNumberedPicks(reply);
    var matched = filterWinesMatchingReply(reply, scopedWines);
    if (!matched.length) return apiWines;
    if (numbered >= 2 && matched.length >= numbered) return matched.slice(0, numbered);
    if (matched.length < apiWines.length) return apiWines;
    if (numbered === 1 && matched.length === 1) return matched;
    if (matched.length === apiWines.length) return matched;
    return apiWines;
  }

  function prepareReplyAndWines(reply, wines, userMessage, mode) {
    if (!wines || !wines.length) {
      return { bubbleText: sanitizeMiraiReplyText(reply), cardWines: [], wineComments: {} };
    }
    var scopedWines = filterWinesForCatalogSubject(wines, userMessage, mode);
    var cleanedReply = sanitizeMiraiReplyText(reply);
    cleanedReply = realignCatalogIntroInReply(cleanedReply, scopedWines, userMessage);
    var cardWines = cardWinesFromApiResponse(cleanedReply, scopedWines, userMessage, mode);
    var blocks = String(cleanedReply || "")
      .split(/\n{2,}/)
      .map(function (block) {
        return block.trim();
      })
      .filter(Boolean);
    var wineComments = {};
    var seenTitles = {};

    blocks.forEach(function (block) {
      if (!isLikelyWinePickBlock(block)) return;
      var names = extractBoldWineNames(block);
      if (!names.length) return;
      var matchedWine = findBestWineForBlock(names, scopedWines, seenTitles);
      if (!matchedWine) return;
      var comment = cleanWineReplyComment(block, matchedWine.title);
      if (comment.length < 8 || isBudgetOnlyComment(comment)) return;
      wineComments[matchedWine.title] = comment;
      seenTitles[matchedWine.title] = true;
    });

    scopedWines.forEach(function (wine) {
      if (wineComments[wine.title]) return;
      var notes = String(wine.tasting_notes || wine.tasting_notes_full || "").trim();
      if (notes) return;
      var reason = sanitizeCardReason(wine.match_reason || wine.pairing_reason || "");
      if (reason && !isGenericCatalogComment(reason)) wineComments[wine.title] = reason;
    });

    return {
      bubbleText: cleanedReply,
      cardWines: cardWines,
      wineComments: wineComments,
    };
  }

  function storefrontRoot() {
    return String(CONFIG.shopUrl || window.location.origin || "").replace(/\/+$/, "");
  }

  function wineProductUrl(wine) {
    var root = storefrontRoot();
    var url = String((wine && wine.url) || "").trim();
    var handle = String((wine && wine.handle) || "").trim();

    if (url && url !== "#") {
      url = url.replace(/\/apps\/sens-ai\/products\//i, "/products/");
      if (/^https?:\/\//i.test(url)) {
        var absoluteMatch = url.match(/^(https?:\/\/[^/]+)(\/products\/[^/?#]+)/i);
        if (absoluteMatch) return absoluteMatch[1] + absoluteMatch[2];
        return url;
      }
      if (url.charAt(0) === "/") return root + url;
      var relativeMatch = url.match(/\/products\/([^/?#]+)/i);
      if (relativeMatch) return root + "/products/" + relativeMatch[1];
      return url;
    }

    if (handle) return root + "/products/" + handle.replace(/^\/+|\/+$/g, "");
    return "#";
  }

  function wineVariantId(wine) {
    var raw = wine && wine.variant_id;
    if (raw == null || raw === "") return null;
    var parsed = Number(raw);
    if (!Number.isFinite(parsed) || parsed <= 0) return null;
    return parsed;
  }

  var FLAVOR_ICON_DEFS = [
    {
      id: "citrus",
      label: "Citrus",
      tone: "white",
      re: /\b(?:citrus|lemon|lime|grapefruit|orange(?:\s+peel)?|yuzu|mandarin|tangerine|pomelo)\b/i,
    },
    {
      id: "apple",
      label: "Apple",
      tone: "white",
      re: /\b(?:apple|green apple|orchard|crisp fruit)\b/i,
    },
    { id: "pear", label: "Pear", tone: "white", re: /\bpear\b/i },
    {
      id: "stone",
      label: "Stone fruit",
      tone: "white",
      re: /\b(?:peach|apricot|nectarine)\b/i,
    },
    {
      id: "tropical",
      label: "Tropical",
      tone: "white",
      re: /\b(?:pineapple|mango|passion\s*fruit|lychee|guava|tropical)\b/i,
    },
    {
      id: "honey",
      label: "Honey",
      tone: "white",
      re: /\b(?:honey|honeyed|beeswax)\b/i,
    },
    {
      id: "mineral",
      label: "Mineral",
      tone: "neutral",
      re: /\b(?:mineral|flint|chalk|slate|wet stone|gunflint)\b/i,
    },
    {
      id: "floral",
      label: "Floral",
      tone: "neutral",
      re: /\b(?:floral|jasmine|white flowers?|violets?|acacia|elderflower)\b/i,
    },
    {
      id: "blackcurrant",
      label: "Blackcurrant",
      tone: "red",
      re: /\b(?:blackcurrant|cassis|black currant)\b/i,
    },
    { id: "plum", label: "Plum", tone: "red", re: /\b(?:plum|prune|damson)\b/i },
    {
      id: "berry",
      label: "Berry",
      tone: "red",
      re: /\b(?:strawberr|raspberr|cranberr|red ber(?:r|ries)|wild ber(?:r|ries))\b/i,
    },
    { id: "cherry", label: "Cherry", tone: "red", re: /\b(?:cherry|cherries|kirsch)\b/i },
    {
      id: "dark",
      label: "Dark fruit",
      tone: "red",
      re: /\b(?:blackberr|blueberr|dark fruit|mulberry|boysenberr)\b/i,
    },
    {
      id: "spice",
      label: "Spice",
      tone: "neutral",
      re: /\b(?:pepper|spice|clove|anise|licorice|vanilla|toast|oak|smok)\b/i,
    },
    {
      id: "herb",
      label: "Herb",
      tone: "neutral",
      re: /\b(?:herb|thyme|rosemary|sage|mint|basil|green bell)\b/i,
    },
  ];

  function inferWineColorTone(wine) {
    var hay = [
      (wine && wine.title) || "",
      (wine && wine.product_type) || "",
      (wine && wine.variant_title) || "",
    ]
      .join(" ")
      .toLowerCase();
    if (
      /\b(?:rouge|red|cabernet|merlot|syrah|shiraz|pinot noir|malbec|nebbiolo|sangiovese|tempranillo|grenache|zinfandel|gamay|beaujolais|fleurie|morgon|moulin[\s\-àa]+vent|brouilly|juli[eé]nas|ch[eé]nas|chiroubles|r[eé]gni[eé]|saint[\s\-]?amour|penfolds\s+bin\s+\d{2,3})\b/.test(
        hay
      )
    ) {
      return "red";
    }
    if (
      /\b(?:blanc|white|riesling|chardonnay|sauvignon\s+blanc|albari[nñ]o|grüner|gruner|chenin|semillon|pinot grigio|viognier|gewürz|gewurz|taïka|taika)\b/.test(
        hay
      ) &&
      !/\bcabernet\s+sauvignon\b/.test(hay)
    ) {
      return "white";
    }
    return "neutral";
  }

  var flavorSvgUid = 0;

  function flavorIconSvg(id) {
    var uid = "flv" + ++flavorSvgUid;
    var gMain = "g-main-" + uid;
    var gHi = "g-hi-" + uid;
    var sh = "shadow-" + uid;
    var stem = "stem-" + uid;
    var svgOpen =
      '<svg class="sens-ai-flavor-box__svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">';
    var defs =
      "<defs>" +
      '<radialGradient id="' +
      gHi +
      '" cx="32%" cy="26%" r="72%"><stop offset="0%" stop-color="#ffffff" stop-opacity=".96"/><stop offset="100%" stop-color="#ffffff" stop-opacity="0"/></radialGradient>' +
      '<linearGradient id="' +
      stem +
      '" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#84c26f"/><stop offset="100%" stop-color="#3f7d3d"/></linearGradient>' +
      '<filter id="' +
      sh +
      '" x="-40%" y="-40%" width="180%" height="200%"><feDropShadow dx="0" dy="1.1" stdDeviation="0.85" flood-color="#2a1a1a" flood-opacity=".22"/></filter>' +
      "</defs>";

    function fruitBody(mainStops, shape, extras) {
      var grad =
        '<linearGradient id="' +
        gMain +
        '" x1="0.22" y1="0.12" x2="0.78" y2="0.92">' +
        mainStops +
        "</linearGradient>";
      return (
        svgOpen +
        defs.replace("</defs>", grad + "</defs>") +
        '<g filter="url(#' +
        sh +
        ')">' +
        shape.replace(/__MAIN__/g, "url(#" + gMain + ")") +
        '<ellipse cx="9.2" cy="8.1" rx="3.1" ry="2.05" fill="url(#' +
        gHi +
        ')" />' +
        (extras || "") +
        "</g></svg>"
      );
    }

    var icons = {
      citrus: fruitBody(
        '<stop offset="0%" stop-color="#fff8a8"/><stop offset="52%" stop-color="#ffd84d"/><stop offset="100%" stop-color="#e0a51d"/>',
        '<circle cx="12" cy="13" r="6.9" fill="__MAIN__" stroke="#c18811" stroke-width=".8"/><path d="M12 7.1v11.8M6.2 13h11.6M8 8.9l8 8.2M16 8.9l-8 8.2" stroke="rgba(255,255,255,.32)" stroke-width=".52" stroke-linecap="round"/>'
      ),
      apple: fruitBody(
        '<stop offset="0%" stop-color="#ff8f8f"/><stop offset="58%" stop-color="#e14d4d"/><stop offset="100%" stop-color="#a81f26"/>',
        '<path d="M12 4.9c.5-1.3 1.7-2.1 3-2.1-.2 1.8-.9 3-2.1 3.8 3 .1 5.4 2.2 5.4 6.1a5.4 5.4 0 0 1-10.8 0c0-3.8 2.4-6 5.4-6.1-1.2-.8-1.9-2-2.1-3.8 1.3 0 2.5.8 3 2.1z" fill="__MAIN__" stroke="#82161b" stroke-width=".8"/><path d="M11.9 5.1c-.2-1 .5-2.1 1.6-2.6" fill="none" stroke="url(#__STEM__)" stroke-width="1.1" stroke-linecap="round"/>'.replace(
          "__STEM__",
          stem
        )
      ),
      pear: fruitBody(
        '<stop offset="0%" stop-color="#eef7a4"/><stop offset="56%" stop-color="#bad05b"/><stop offset="100%" stop-color="#7ea03d"/>',
        '<path d="M12 4.6c.8-1.5 2.2-2.4 3.3-1.8-.3 1.7-1.2 2.9-2.5 3.7 2.8.7 4.8 3 4.8 6.3a5.5 5.5 0 0 1-11 0c0-3.3 2-5.6 4.8-6.3-1.3-.8-2.2-2-2.5-3.7 1.1-.6 2.5.3 3.1 1.8z" fill="__MAIN__" stroke="#688237" stroke-width=".78"/>'
      ),
      stone: fruitBody(
        '<stop offset="0%" stop-color="#ffd4ae"/><stop offset="56%" stop-color="#f39d72"/><stop offset="100%" stop-color="#d67145"/>',
        '<circle cx="12" cy="13.3" r="6.4" fill="__MAIN__" stroke="#bd6140" stroke-width=".75"/><path d="M11.6 7.2c.6-1 1.7-1.5 2.7-1.1" fill="none" stroke="url(#__STEM__)" stroke-width="1" stroke-linecap="round"/>'.replace(
          "__STEM__",
          stem
        )
      ),
      tropical: fruitBody(
        '<stop offset="0%" stop-color="#ffe287"/><stop offset="55%" stop-color="#f7c544"/><stop offset="100%" stop-color="#d99a16"/>',
        '<path d="M8 10c1.5-3.2 4.4-4.7 8-3.8-.7 3.5-3.3 5.8-6.5 6.8.4 2 1.8 3.4 3.9 3.9-2.6-.5-4.6-2.2-5.4-4.6z" fill="__MAIN__" stroke="#b7800f" stroke-width=".7"/><path d="M15.3 7.3l2.1-2M15.5 9.1l2.5.5" stroke="url(#__STEM__)" stroke-width="1" stroke-linecap="round"/>'.replace(
          /__STEM__/g,
          stem
        )
      ),
      honey: fruitBody(
        '<stop offset="0%" stop-color="#ffe79a"/><stop offset="57%" stop-color="#f4bf3d"/><stop offset="100%" stop-color="#c9861d"/>',
        '<path d="M8.1 11h7.8l-1.1 6.9H9.2L8.1 11z" fill="__MAIN__" stroke="#b06e16" stroke-width=".75"/><path d="M9.2 8.2a2.8 2.8 0 0 1 5.6 0V11H9.2V8.2z" fill="rgba(255,238,170,.86)" stroke="#d3a23f" stroke-width=".58"/>'
      ),
      mineral: fruitBody(
        '<stop offset="0%" stop-color="#d5dfeb"/><stop offset="58%" stop-color="#9fb3c8"/><stop offset="100%" stop-color="#738aa0"/>',
        '<path d="M6 17l3-9 3 5 3-7 3 11H6z" fill="__MAIN__" stroke="#607a91" stroke-width=".75"/><path d="M6 17h12" stroke="rgba(255,255,255,.7)" stroke-width=".8"/>'
      ),
      floral: fruitBody(
        '<stop offset="0%" stop-color="#ffd3eb"/><stop offset="55%" stop-color="#f5a0cd"/><stop offset="100%" stop-color="#cb6699"/>',
        '<circle cx="12" cy="12.2" r="2.5" fill="__MAIN__"/><circle cx="8.5" cy="10.1" r="2.2" fill="url(#__AUX__)"/><circle cx="15.5" cy="10.1" r="2.2" fill="url(#__AUX__)"/><circle cx="9.4" cy="15.1" r="2.05" fill="url(#__AUX__)"/><circle cx="14.6" cy="15.1" r="2.05" fill="url(#__AUX__)"/>'.replace(
          /__AUX__/g,
          gHi
        )
      ),
      blackcurrant: fruitBody(
        '<stop offset="0%" stop-color="#8b63aa"/><stop offset="56%" stop-color="#4d2a6e"/><stop offset="100%" stop-color="#28133c"/>',
        '<circle cx="9" cy="13" r="3.2" fill="__MAIN__"/><circle cx="14.8" cy="11.7" r="3" fill="__MAIN__"/><circle cx="12" cy="16.4" r="2.8" fill="__MAIN__" opacity=".95"/>'
      ),
      plum: fruitBody(
        '<stop offset="0%" stop-color="#c18ada"/><stop offset="57%" stop-color="#844ca1"/><stop offset="100%" stop-color="#4e2965"/>',
        '<ellipse cx="12" cy="13.2" rx="5.6" ry="6.5" fill="__MAIN__" stroke="#4b2a61" stroke-width=".75"/><path d="M12 6.7c.6-1.1 1.8-1.7 2.8-1.2" fill="none" stroke="url(#__STEM__)" stroke-width="1" stroke-linecap="round"/>'.replace(
          "__STEM__",
          stem
        )
      ),
      berry: fruitBody(
        '<stop offset="0%" stop-color="#ffafc3"/><stop offset="56%" stop-color="#e0567e"/><stop offset="100%" stop-color="#a92c51"/>',
        '<circle cx="9.4" cy="13" r="3" fill="__MAIN__"/><circle cx="14" cy="12.1" r="2.8" fill="__MAIN__" opacity=".92"/><circle cx="11.6" cy="16.5" r="2.5" fill="__MAIN__" opacity=".85"/>'
      ),
      cherry: fruitBody(
        '<stop offset="0%" stop-color="#ff8f97"/><stop offset="57%" stop-color="#d53c48"/><stop offset="100%" stop-color="#881725"/>',
        '<circle cx="10" cy="14" r="3.9" fill="__MAIN__"/><circle cx="15.4" cy="12.6" r="3.5" fill="__MAIN__" opacity=".95"/><path d="M12.4 7c.5-1 1.5-1.6 2.4-1.2" fill="none" stroke="url(#__STEM__)" stroke-width="1" stroke-linecap="round"/>'.replace(
          "__STEM__",
          stem
        )
      ),
      dark: fruitBody(
        '<stop offset="0%" stop-color="#8a75a7"/><stop offset="56%" stop-color="#3e2b5a"/><stop offset="100%" stop-color="#1d122b"/>',
        '<circle cx="9" cy="13.5" r="3.2" fill="__MAIN__"/><circle cx="14.6" cy="12.1" r="3" fill="__MAIN__" opacity=".95"/><circle cx="12" cy="16.5" r="2.7" fill="__MAIN__" opacity=".88"/>'
      ),
      spice: fruitBody(
        '<stop offset="0%" stop-color="#ffd3ab"/><stop offset="56%" stop-color="#d79a5d"/><stop offset="100%" stop-color="#8c5a2f"/>',
        '<circle cx="12" cy="12.2" r="6.9" fill="__MAIN__" stroke="#7a4b28" stroke-width=".75"/><path d="M12 5.4v13.4M5.3 12.1h13.4" stroke="rgba(255,255,255,.5)" stroke-width=".8" stroke-linecap="round"/>'
      ),
      herb: fruitBody(
        '<stop offset="0%" stop-color="#b6e6bb"/><stop offset="56%" stop-color="#69b673"/><stop offset="100%" stop-color="#2f6f44"/>',
        '<path d="M12 20V8M8 12c2-3 4-4 4-6M16 12c-2-3-4-4-4-6" stroke="__MAIN__" stroke-width="1.85" stroke-linecap="round"/>'
      ),
    };
    return icons[id] || icons.herb;
  }

  function detectFlavorIcons(sourceText, wine, maxCount) {
    var hay = cleanDisplayText(sourceText).toLowerCase();
    if (!hay) return [];
    var wineTone = inferWineColorTone(wine);
    var scored = [];
    FLAVOR_ICON_DEFS.forEach(function (def) {
      if (!def.re.test(hay)) return;
      var score = 1;
      if (wineTone !== "neutral" && def.tone === wineTone) score += 2;
      if (def.tone === "neutral") score += 0.5;
      scored.push({ def: def, score: score });
    });
    scored.sort(function (a, b) {
      return b.score - a.score;
    });
    var picked = [];
    var seen = {};
    for (var i = 0; i < scored.length && picked.length < (maxCount || 4); i++) {
      if (seen[scored[i].def.id]) continue;
      seen[scored[i].def.id] = true;
      picked.push(scored[i].def);
    }
    return picked;
  }

  var SHOW_FLAVOR_ICON_BOX = false;

  function buildFlavorIconBoxHtml(flavors) {
    if (!SHOW_FLAVOR_ICON_BOX || !flavors || !flavors.length) return "";
    var html =
      '<div class="sens-ai-flavor-box" role="group" aria-label="Detected tasting notes · 風味圖示">';
    flavors.forEach(function (flavor) {
      html +=
        '<span class="sens-ai-flavor-box__icon sens-ai-flavor-box__icon--' +
        escapeHtml(flavor.id) +
        '" title="' +
        escapeHtml(flavor.label) +
        '" aria-label="' +
        escapeHtml(flavor.label) +
        '">' +
        flavorIconSvg(flavor.id) +
        "</span>";
    });
    html += "</div>";
    return html;
  }

  function splitReplyBlocks(text) {
    var normalized = String(text || "").trim();
    if (!normalized) return [];
    var paraBlocks = normalized
      .split(/\n{2,}/)
      .map(function (block) {
        return block.trim();
      })
      .filter(Boolean);
    var numberedParas = paraBlocks.filter(function (block) {
      return /^\d+[\.、．]\s/.test(block);
    });
    if (numberedParas.length >= 2 || (paraBlocks.length >= 2 && numberedParas.length >= 1)) {
      return paraBlocks;
    }
    var lines = normalized
      .split(/\n/)
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);
    if (lines.length <= 1) return [normalized];
    var blocks = [];
    var current = "";
    lines.forEach(function (line) {
      if (/^\d+[\.、．]\s+/.test(line)) {
        if (current) blocks.push(current);
        current = line;
      } else if (current) {
        current += " " + line;
      } else {
        blocks.push(line);
      }
    });
    if (current) blocks.push(current);
    return blocks.length ? blocks : [normalized];
  }

  function splitPickHeadAndNotes(block) {
    var text = String(block || "").trim();
    var listPrefix = "";
    var listMatch = text.match(/^(\d+[\.、．]\s*)/);
    if (listMatch) {
      listPrefix = listMatch[1];
      text = text.slice(listMatch[0].length);
    }

    var patterns = [
      /^(\[[^\]]+\]\((?:https?:\/\/[^)\s]+\/products\/[a-z0-9][a-z0-9-]*|\/products\/[a-z0-9][a-z0-9-]*)\))\s+([\s\S]{16,})$/i,
      /^([\s\S]*?\((?:Robert Parker(?:'s)?(?:'s)?\s*(?:rating)?|RP\s*:|James Suckling(?:'s)?(?:'s)?\s*(?:rating)?|JS\s*:|Wine Enthusiast(?:'s)?(?:'s)?\s*(?:rating)?|WE\s*:)[^)]*\))\s+([\s\S]{16,})$/i,
      /^([\s\S]*?\b\d+(?:\.\d+)?%\s*ABV[^)]*\))\s+([\s\S]{16,})$/i,
      /^([\s\S]*?\b\d+(?:\.\d+)?%\s*ABV[^.)\n]{0,48})\s+([\s\S]{16,})$/i,
      /^([\s\S]*?points\))\s+([\s\S]{16,})$/i,
      /^(.+?)\s*[—–]\s+([\s\S]{16,})$/,
      /^(.+?)\s+-\s+([\s\S]{16,})$/,
    ];
    for (var i = 0; i < patterns.length; i++) {
      var match = text.match(patterns[i]);
      if (match) {
        return { listPrefix: listPrefix, head: match[1].trim(), notes: match[2].trim() };
      }
    }
    return { listPrefix: listPrefix, head: text.trim(), notes: "" };
  }

  function extractPickNumber(block, fallbackIdx) {
    var match = String(block || "").match(/^\s*(\d+)[\.、．]/);
    if (match) return match[1];
    return String(fallbackIdx || 1);
  }

  function resolvePickNotes(block, wine, wineComments) {
    var split = splitPickHeadAndNotes(block);
    var notesFromBlock = stripTrailingEllipsis(split.notes || "");
    var commentFromBlock = wine ? cleanWineReplyComment(block, wine.title) : "";
    var texts = wine ? cardCommentPreviewFull(wine, wineComments[wine.title]) : { preview: "", full: "" };
    var preview = notesFromBlock || commentFromBlock || stripTrailingEllipsis(texts.preview || "");
    var full = stripTrailingEllipsis(texts.full || preview || commentFromBlock || notesFromBlock);

    if (notesFromBlock && full && full.length > notesFromBlock.length + 8) {
      preview = notesFromBlock;
    } else if (commentFromBlock && full.length > commentFromBlock.length + 8) {
      preview = stripTrailingEllipsis(commentFromBlock);
    } else if (!preview) {
      preview = stripTrailingEllipsis(texts.preview || "");
    }

    if (full.length < preview.length + 8 && textLooksTruncated(preview) && texts.full) {
      full = stripTrailingEllipsis(texts.full);
    }

    if (!preview && commentFromBlock) {
      preview = stripTrailingEllipsis(commentFromBlock);
      full = stripTrailingEllipsis(texts.full || preview);
    }

    return { split: split, preview: preview, full: full };
  }

  function buildWinePickBlockHtml(block, wines, wineComments, seenTitles, fallbackIdx) {
    var names = extractBoldWineNames(block);
    var wine = findBestWineForBlock(names, wines, seenTitles);
    if (wine) seenTitles[wine.title] = true;

    var pickNum = extractPickNumber(block, fallbackIdx);
    var noteParts = resolvePickNotes(block, wine, wineComments);
    var split = noteParts.split;
    var headSource = split.head;
    if (wine) {
      var canonicalUrl = wineProductUrl(wine);
      if (canonicalUrl && canonicalUrl !== "#") {
        headSource = buildWineMarkdownLink(wine.title, canonicalUrl);
      }
    }
    var headHtml = formatReply(headSource, wines);
    var flavorSource = [
      noteParts.full,
      noteParts.preview,
      wine && wine.tasting_notes_full,
      wine && wine.tasting_notes,
      wine && wine.match_reason,
    ].join(" ");
    var flavors = detectFlavorIcons(flavorSource, wine, 4);
    var flavorHtml = buildFlavorIconBoxHtml(flavors);

    var notesHtml = "";
    var notesPreview = pickNotesDisplayText(noteParts.preview, noteParts.full);
    if (notesPreview) {
      if (shouldUseReadMoreCard(noteParts.preview, noteParts.full)) {
        notesHtml = buildReadMoreHtml(
          noteParts.preview,
          "sens-ai-read-more--pick",
          noteParts.full || noteParts.preview
        );
      } else {
        notesHtml =
          '<p class="sens-ai-wine-pick__notes-text">' + escapeHtml(notesPreview) + "</p>";
      }
    }

    return (
      '<article class="sens-ai-wine-pick">' +
      '<div class="sens-ai-wine-pick__header">' +
      '<span class="sens-ai-wine-pick__num">' +
      escapeHtml(pickNum + ".") +
      "</span>" +
      '<div class="sens-ai-wine-pick__meta">' +
      headHtml +
      "</div>" +
      "</div>" +
      flavorHtml +
      notesHtml +
      "</article>"
    );
  }

  function buildStructuredReplyHtml(text, wines, wineComments) {
    if (!wines || !wines.length) return null;
    wineComments = wineComments || {};
    var blocks = splitReplyBlocks(text);
    if (!blocks.length) return null;

    var parts = partitionReplyBlocks(blocks);
    var introBlocks = parts.introBlocks;
    var pickBlocks = parts.pickBlocks;
    var outroBlocks = parts.outroBlocks;
    if (!pickBlocks.length) return null;

    var numberedPicks = pickBlocks.filter(function (block) {
      return /^\d+[\.、．]\s/.test(block);
    }).length;
    if (numberedPicks < 1 && pickBlocks.length < 2) return null;

    var html = "";
    if (introBlocks.length) {
      html +=
        '<div class="sens-ai-reply-intro">' + formatReply(introBlocks.join("\n\n"), wines) + "</div>";
    }
    html += '<div class="sens-ai-wine-pick-list">';
    var seenTitles = {};
    pickBlocks.forEach(function (block, idx) {
      html += buildWinePickBlockHtml(block, wines, wineComments, seenTitles, idx + 1);
    });
    html += "</div>";
    if (outroBlocks.length) {
      html +=
        '<div class="sens-ai-reply-outro">' + formatReply(outroBlocks.join("\n\n"), wines) + "</div>";
    }
    return html;
  }

  function formatReplyWithReadMore(text, wines, wineComments) {
    var trimmed = stripMalformedBudgetPhrases(String(text || "").trim());
    if (!trimmed) return "";
    wineComments = wineComments || {};
    if (wines && wines.length) {
      trimmed = enrichTruncatedReplyLines(trimmed, wines, wineComments);
      trimmed = repairWineMarkdownSyntax(trimmed);
      trimmed = normalizeWineMarkdownLinks(trimmed, wines);
      trimmed = injectWineTitleLinks(trimmed, wines);
    } else {
      trimmed = stripOrphanProductUrls(trimmed);
    }
    if (wines && wines.length) {
      var structured = buildStructuredReplyHtml(trimmed, wines, wineComments);
      if (structured) return structured;
    }
    var formatted = formatReply(trimmed, wines);
    if (!shouldUseReadMoreReply(trimmed, trimmed)) return formatted;
    return buildReadMoreHtml(trimmed, "sens-ai-read-more--reply", trimmed, formatted, wines);
  }

  function enrichTruncatedReplyLines(text, wines, wineComments) {
    if (!wines || !wines.length) return text;
    var lines = String(text || "").split("\n");
    var seenTitles = {};
    var changed = false;
    var enriched = lines.map(function (line) {
      var trimmed = line.trim();
      if (!trimmed || !/\*\*[^*]+\*\*/.test(trimmed)) return line;
      if (!textLooksTruncated(trimmed) && trimmed.length < 220) return line;
      var names = extractBoldWineNames(trimmed);
      if (!names.length) return line;
      var matchedWine = findBestWineForBlock(names, wines, seenTitles);
      if (!matchedWine) return line;
      seenTitles[matchedWine.title] = true;
      var texts = cardCommentPreviewFull(matchedWine, wineComments[matchedWine.title]);
      var full = String(texts.full || "").trim();
      if (!full || full.length <= stripTrailingEllipsis(trimmed).length + 8) return line;
      var rebuilt = rebuildTruncatedReplyLine(trimmed, full);
      if (rebuilt && rebuilt !== trimmed) {
        changed = true;
        return rebuilt;
      }
      return line;
    });
    return changed ? enriched.join("\n") : text;
  }

  function rebuildTruncatedReplyLine(line, fullText) {
    var trimmed = String(line || "").trim();
    var full = String(fullText || "").trim();
    if (!trimmed || !full) return trimmed;
    var prefixMatch = trimmed.match(/^(\d+\.\s*)/);
    var listPrefix = prefixMatch ? prefixMatch[1] : "";
    var dashMatch = trimmed.match(/^(.*?)([—–\-]\s*)(.+)$/);
    if (dashMatch) {
      var head = dashMatch[1];
      var dash = dashMatch[2];
      var desc = full.replace(/^\d+\.\s*[—–\-]\s*/, "");
      return listPrefix + head.slice(listPrefix.length) + dash + desc;
    }
    if (textLooksTruncated(trimmed)) {
      return listPrefix + full.replace(/^\d+\.\s*/, "");
    }
    return trimmed;
  }

  function isGenericCatalogComment(text) {
    var cleaned = String(text || "").trim();
    if (!cleaned) return true;
    if (isBudgetOnlyComment(cleaned)) return true;
    if (
      /\bas requested\b|\byou asked for\b|\bfits your search\b|\bmatches what you asked\b|\bmatches your search\b/i.test(
        cleaned
      ) ||
      /應該啱襯|符合你今次搜尋|風格符合你今次搜尋|風格貼合今次搜尋/i.test(cleaned)
    ) {
      return true;
    }
    if (
      /^Structured (?:Cabernet|Bordeaux|Barolo|Shiraz)\b/i.test(cleaned) ||
      /^Classic Bordeaux profile\b/i.test(cleaned) ||
      /^Shiraz fruit and spice\b/i.test(cleaned) ||
      /^Chardonnay body matches\b/i.test(cleaned) ||
      /^Riesling's acidity and fruit stand out\b/i.test(cleaned) ||
      /^Silky, gentle Pinot Noir style\b/i.test(cleaned) ||
      /^Sparkling freshness fits your search\b/i.test(cleaned)
    ) {
      return true;
    }
    return false;
  }

  function defaultWineComment(wine) {
    var notesPreview = String(wine.tasting_notes || "").trim();
    if (notesPreview) return notesPreview;
    var reason = sanitizeCardReason(wine.match_reason || wine.pairing_reason || "");
    if (reason) return reason;
    var notesFull = String(wine.tasting_notes_full || "").trim();
    if (notesFull) return notesFull;
    var title = String(wine.title || "this bottle").trim();
    return "A curated pick from the SENS cellar — " + title + ".";
  }

  function cardCommentPreviewFull(wine, replyComment) {
    var comment = String(replyComment || "").trim();
    if (comment) {
      comment = stripWineMarkdownFromComment(comment, wine && wine.title);
      comment = stripProvenanceTail(comment);
      comment = stripMalformedBudgetPhrases(comment);
    }
    if (comment && isBudgetOnlyComment(comment)) comment = "";
    if (comment && isGenericCatalogComment(comment)) comment = "";

    var notesPreview = String(wine.tasting_notes || "").trim();
    var notesFull = String(wine.tasting_notes_full || "").trim();
    var reason = sanitizeCardReason(wine.match_reason || wine.pairing_reason || "");
    if (reason && isGenericCatalogComment(reason)) reason = "";

    var preview = notesPreview || comment || reason || defaultWineComment(wine);
    var full = notesFull || notesPreview || comment || reason || preview;

    if (notesFull && notesFull.length > stripTrailingEllipsis(preview).length + 8) {
      full = notesFull;
      if (!comment || textLooksTruncated(comment) || comment === notesPreview) {
        preview = notesPreview || preview;
      }
      var prefixMatch = (comment || preview).match(/^(\d+\.\s*[—–\-]\s*)/);
      if (prefixMatch && full.indexOf(prefixMatch[1]) !== 0) {
        full = prefixMatch[1] + full.replace(/^\d+\.\s*[—–\-]\s*/, "");
      }
    } else if (reason && reason.length > stripTrailingEllipsis(preview).length + 8) {
      full = reason;
      if (textLooksTruncated(preview)) preview = notesPreview || reason;
    } else if (comment && !textLooksTruncated(comment)) {
      preview = comment;
      full = comment;
    }

    if (preview.length > full.length) {
      var swap = preview;
      preview = full;
      full = swap;
    }

    return { preview: preview, full: full };
  }

  function wineCardDescription(wine, replyComment) {
    return cardCommentPreviewFull(wine, replyComment);
  }

  function toggleReadMore(btn) {
    var wrap = btn.closest("[data-read-more]");
    if (!wrap) return;
    var content = wrap.querySelector(".sens-ai-read-more__content");
    var expanded = wrap.classList.toggle("is-expanded");
    var preview = wrap.getAttribute("data-read-more-preview") || "";
    var full = wrap.getAttribute("data-read-more-full") || preview;
    var isReply = wrap.classList.contains("sens-ai-read-more--reply");
    var wines = [];
    if (isReply) {
      var rawWines = wrap.getAttribute("data-read-more-wines") || "";
      if (rawWines) {
        try {
          wines = JSON.parse(rawWines);
        } catch (e) {
          wines = [];
        }
      }
    }
    if (content) {
      if (isReply) {
        content.innerHTML = formatReply(expanded ? full : preview, wines);
      } else if (wrap.classList.contains("sens-ai-read-more--pick") || full !== preview) {
        content.textContent = expanded ? full : preview;
      }
    }
    btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    btn.textContent = expanded ? READ_MORE_LABEL_LESS : READ_MORE_LABEL;
  }

  function formatPrice(value) {
    if (value == null || value === "") return "";
    var n = Number(value);
    if (isNaN(n)) return "";
    return "HK$" + n.toLocaleString("en-HK", { maximumFractionDigits: 0 });
  }

  function parseWinePriceValue(value) {
    if (value == null || value === "") return null;
    var n = Number(value);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  function wineSalePriceValue(wine) {
    if (!wine) return null;
    return parseWinePriceValue(wine.price != null ? wine.price : wine.price_hkd);
  }

  function wineCompareAtPriceValue(wine) {
    if (!wine) return null;
    var compare = parseWinePriceValue(
      wine.compare_at_price != null ? wine.compare_at_price : wine.compare_at_price_hkd
    );
    var sale = wineSalePriceValue(wine);
    if (!compare || !sale || compare <= sale) return null;
    return compare;
  }

  function buildWinePriceHtml(wine) {
    var sale = wineSalePriceValue(wine);
    if (!sale) return "";
    var compare = wineCompareAtPriceValue(wine);
    var saleHtml = '<span class="sens-ai-wine-price__sale">' + formatPrice(sale) + "</span>";
    if (!compare) {
      return '<p class="sens-ai-wine-price">' + saleHtml + "</p>";
    }
    return (
      '<p class="sens-ai-wine-price sens-ai-wine-price--on-sale">' +
      saleHtml +
      '<span class="sens-ai-wine-price__was">' +
      formatPrice(compare) +
      "</span></p>"
    );
  }

  function scrollMessages() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function scrollMessageIntoView(wrap) {
    if (!wrap || !messagesEl) {
      scrollMessages();
      return;
    }
    var bubble = wrap.querySelector(".sens-ai-msg__bubble");
    var target = bubble || wrap;
    var top = target.offsetTop - messagesEl.offsetTop - 12;
    messagesEl.scrollTop = Math.max(0, top);
  }

  function criticScoresFromTitle(title) {
    var re = /\b(RP|JS|WS|BH|WE|WH|NM|VN|Vinous)\s*:?\s*(\d{2})/gi;
    var parts = [];
    var seen = {};
    var match;
    while ((match = re.exec(title || "")) !== null) {
      var src = match[1].toUpperCase();
      if (src === "VINOUS") src = "VN";
      var label = src + ":" + match[2];
      if (seen[label]) continue;
      seen[label] = true;
      parts.push(label);
    }
    return parts.join(" · ");
  }

  function wineProfileText(wine, cardComment) {
    return [
      wine.tasting_notes,
      wine.tasting_notes_full,
      cardComment,
      wine.match_reason,
      wine.pairing_reason,
      wine.title,
    ]
      .filter(Boolean)
      .join(" ");
  }

  var COMPLEXITY_PROFILE_FLOOR = 3.5;

  function hasComplexityNotes(text) {
    var t = String(text || "").toLowerCase();
    if (!t) return false;
    if (
      /\b(?:not|no|little|lack(?:ing|s)?|without|low|simple|straightforward)\s+(?:much\s+)?complex/i.test(
        t
      )
    ) {
      return false;
    }
    if (/\bcomplex(?:ity|ities)?\b/.test(t)) return true;
    if (
      /\b(?:good|high|nice|great|rich|notable|impressive|remarkable|deep|wonderful|beautiful|fine|lovely|mult(?:i|idimensional))\s+complex(?:ity|ities)?\b/.test(
        t
      )
    ) {
      return true;
    }
    if (/\blayer(?:ed|ing)\b/.test(t) && /\b(?:flavou?r|aroma|nose|palate|wine|profile|character)\b/.test(t)) {
      return true;
    }
    if (/复杂性|複雜|层次丰富|層次豐富|层次复杂|層次複雜|复杂度高|複雜度高|層次感/.test(t)) {
      return true;
    }
    return false;
  }

  function applyComplexityProfileFloor(profile, text) {
    if (!profile || !hasComplexityNotes(text)) return profile;
    return profile.map(function (dim) {
      if (dim.key !== "body" && dim.key !== "finish") return dim;
      if (dim.value >= COMPLEXITY_PROFILE_FLOOR) return dim;
      return {
        key: dim.key,
        label: dim.label,
        value: clampProfileScore(COMPLEXITY_PROFILE_FLOOR),
      };
    });
  }

  var MIN_NOTES_FOR_RADAR = 50;
  var MIN_NOTES_STRONG = 80;
  var MIN_PROFILE_SPREAD = 0.35;

  function profileSpread(profile) {
    if (!profile || !profile.length) return 0;
    var vals = profile.map(function (d) {
      return Number(d.value);
    });
    return Math.max.apply(null, vals) - Math.min.apply(null, vals);
  }

  function profileFromServer(wine) {
    if (wine.show_tasting_profile === false) return null;
    var raw = wine.tasting_profile;
    if (!raw || !Array.isArray(raw) || raw.length < 5) return null;
    return raw.map(function (d) {
      return {
        key: d.key,
        label: d.label || d.key,
        value: clampProfileScore(d.value),
      };
    });
  }

  function shouldShowTastingRadar(wine, profile) {
    return !!(profile && profile.length >= 5);
  }

  function resolveWineProfile(wine, cardComment) {
    var text = wineProfileText(wine, cardComment);
    var server = profileFromServer(wine);
    var profile = server || buildWineProfileDimensions(wine, cardComment);
    return applyComplexityProfileFloor(profile, text);
  }

  function clampProfileScore(value) {
    var n = Number(value);
    if (isNaN(n)) n = 3.2;
    return Math.max(1.8, Math.min(4.9, Math.round(n * 10) / 10));
  }

  function keywordScore(text, patterns, base, boost) {
    var hits = 0;
    for (var i = 0; i < patterns.length; i++) {
      if (patterns[i].test(text)) hits += 1;
    }
    return clampProfileScore(base + Math.min(hits * (boost || 0.22), 1.35));
  }

  function extractVintageYear(text) {
    var match = String(text || "").match(/\b(19|20)\d{2}\b/);
    return match ? parseInt(match[0], 10) : null;
  }

  function criticScoreAverage(text) {
    var re = /\b(RP|JS|WS|BH|WE|WH|NM|VN|Vinous)\s*:?\s*(\d{2})/gi;
    var total = 0;
    var count = 0;
    var match;
    while ((match = re.exec(text || "")) !== null) {
      total += parseInt(match[2], 10);
      count += 1;
    }
    if (!count) return null;
    return total / count;
  }

  function buildWineProfileDimensions(wine, cardComment) {
    var text = wineProfileText(wine, cardComment).toLowerCase();
    var vintage = wine.vintage || extractVintageYear(wine.title || "");
    var vintageNum = vintage ? parseInt(String(vintage), 10) : null;
    var nowYear = new Date().getFullYear();
    var vintageScore = 3.1;
    if (vintageNum && vintageNum >= 1950 && vintageNum <= nowYear) {
      var age = nowYear - vintageNum;
      if (age <= 3) vintageScore = 3.4;
      else if (age <= 8) vintageScore = 3.8;
      else if (age <= 18) vintageScore = 4.2;
      else if (age <= 30) vintageScore = 4.0;
      else vintageScore = 3.6;
    }

    var criticAvg = criticScoreAverage(text);
    var rankingScore = criticAvg ? clampProfileScore(1.8 + (criticAvg - 80) * 0.08) : 3.0;

    return [
      {
        key: "body",
        label: "Body",
        value: keywordScore(
          text,
          [
            /full[\s-]?bod/i,
            /rich/i,
            /bold/i,
            /concentrated/i,
            /dense/i,
            /heavy/i,
            /complex(?:ity|ities)?/i,
            /layer(?:ed|ing)/i,
            /酒體|醇厚|豐滿|濃郁|複雜|复杂/,
          ],
          /light|delicate|elegant|thin|crisp|轻盈|輕盈|清爽/.test(text) ? 2.8 : 3.35,
          0.2
        ),
      },
      {
        key: "acidity",
        label: "Acidity",
        value: keywordScore(
          text,
          [
            /acid/i,
            /crisp/i,
            /fresh/i,
            /bright/i,
            /zesty/i,
            /vibrant/i,
            /酸度|清脆|爽脆|明亮/,
          ],
          3.0,
          0.24
        ),
      },
      {
        key: "aroma",
        label: "Aroma",
        value: keywordScore(
          text,
          [
            /aroma/i,
            /nose/i,
            /bouquet/i,
            /berry|cherry|plum|citrus|floral|spice|oak|vanilla|mineral/i,
            /香氣|芳香|果香|花香|礦物/,
          ],
          3.15,
          0.21
        ),
      },
      {
        key: "aging",
        label: "Cellaring",
        value: keywordScore(
          text,
          [
            /age/i,
            /cellar/i,
            /cellaring/i,
            /tannin|structure|grip|backbone/i,
            /long[\s-]?term/i,
            /陳年|適飲|潛力|結構|單寧/,
          ],
          vintageScore - 0.15,
          0.2
        ),
      },
      {
        key: "finish",
        label: "Finish",
        value: keywordScore(
          text,
          [
            /finish/i,
            /aftertaste/i,
            /persistent/i,
            /lingering/i,
            /length/i,
            /long/i,
            /complex(?:ity|ities)?/i,
            /layer(?:ed|ing)/i,
            /餘韻|尾韻|回甘|複雜|复杂/,
          ],
          3.05,
          0.22
        ),
      },
    ].map(function (dim) {
      if (dim.key === "aging" && criticAvg) {
        dim.value = clampProfileScore((dim.value + rankingScore) / 2);
      }
      return dim;
    });
  }

  var PROFILE_BAR_BASELINE = 3.0;
  var PROFILE_BAR_CONTRAST = 1.5;

  var MODERN_PRODUCT_BAR_THEMES = {
    white_wine: {
      fill: "linear-gradient(90deg, #f0d878 0%, #c9a227 100%)",
      track: "rgba(201, 162, 39, 0.22)",
      value: "#8a6f12",
    },
    red_wine: {
      fill: "linear-gradient(90deg, #c93850 0%, #8b1a2d 100%)",
      track: "rgba(139, 26, 45, 0.22)",
      value: "#8b1a2d",
    },
    rose_wine: {
      fill: "linear-gradient(90deg, #f4a8a8 0%, #d46b6b 100%)",
      track: "rgba(212, 107, 107, 0.2)",
      value: "#b84f4f",
    },
    sparkling: {
      fill: "linear-gradient(90deg, #f5e6a3 0%, #d4af37 100%)",
      track: "rgba(212, 175, 55, 0.22)",
      value: "#9a7b12",
    },
    sparkling_rose: {
      fill: "linear-gradient(90deg, #f5c4c4 0%, #e08888 100%)",
      track: "rgba(224, 136, 136, 0.2)",
      value: "#b85a5a",
    },
    fortified: {
      fill: "linear-gradient(90deg, #c4824a 0%, #7a4518 100%)",
      track: "rgba(122, 69, 24, 0.2)",
      value: "#7a4518",
    },
    orange_wine: {
      fill: "linear-gradient(90deg, #e08a3c 0%, #b35900 100%)",
      track: "rgba(179, 89, 0, 0.2)",
      value: "#a04f00",
    },
    whisky: {
      fill: "linear-gradient(90deg, #d4a054 0%, #8b4513 100%)",
      track: "rgba(139, 69, 19, 0.18)",
      value: "#7a3d10",
    },
    bourbon: {
      fill: "linear-gradient(90deg, #d4763a 0%, #a0522d 100%)",
      track: "rgba(160, 82, 45, 0.18)",
      value: "#8a4520",
    },
    gin: {
      fill: "linear-gradient(90deg, #d8e8f0 0%, #9bb8c9 100%)",
      track: "rgba(155, 184, 201, 0.24)",
      value: "#4f7284",
    },
  };

  var PRODUCT_BAR_THEMES = {
    white_wine: {
      fill: "linear-gradient(90deg, #e8d774 0%, #c9a227 100%)",
      track: "rgba(201, 162, 39, 0.14)",
      value: "#9a7b1a",
    },
    red_wine: {
      fill: "linear-gradient(90deg, #c45c6a 0%, #6b1d2a 100%)",
      track: "rgba(125, 34, 53, 0.1)",
      value: "#7d2235",
    },
    rose_wine: {
      fill: "linear-gradient(90deg, #f4a8a8 0%, #d46b6b 100%)",
      track: "rgba(212, 107, 107, 0.14)",
      value: "#c45f5f",
    },
    sparkling: {
      fill: "linear-gradient(90deg, #f5e6a3 0%, #d4af37 100%)",
      track: "rgba(212, 175, 55, 0.14)",
      value: "#b8941f",
    },
    sparkling_rose: {
      fill: "linear-gradient(90deg, #f5c4c4 0%, #e08888 100%)",
      track: "rgba(224, 136, 136, 0.14)",
      value: "#c96b6b",
    },
    fortified: {
      fill: "linear-gradient(90deg, #a66b3a 0%, #5c3317 100%)",
      track: "rgba(92, 51, 23, 0.14)",
      value: "#6b3a1f",
    },
    orange_wine: {
      fill: "linear-gradient(90deg, #e08a3c 0%, #b35900 100%)",
      track: "rgba(179, 89, 0, 0.14)",
      value: "#b35900",
    },
    whisky: {
      fill: "linear-gradient(90deg, #d4a054 0%, #8b4513 100%)",
      track: "rgba(139, 69, 19, 0.12)",
      value: "#8b4513",
    },
    bourbon: {
      fill: "linear-gradient(90deg, #d4763a 0%, #a0522d 100%)",
      track: "rgba(160, 82, 45, 0.12)",
      value: "#a0522d",
    },
    gin: {
      fill: "linear-gradient(90deg, #d8e8f0 0%, #9bb8c9 100%)",
      track: "rgba(155, 184, 201, 0.16)",
      value: "#6f8fa3",
    },
    cognac: {
      fill: "linear-gradient(90deg, #d9a441 0%, #b87333 100%)",
      track: "rgba(184, 115, 51, 0.14)",
      value: "#b87333",
    },
    armagnac: {
      fill: "linear-gradient(90deg, #c97b4a 0%, #6b3a2a 100%)",
      track: "rgba(107, 58, 42, 0.14)",
      value: "#6b3a2a",
    },
    rum: {
      fill: "linear-gradient(90deg, #f0ead6 0%, #d4b896 100%)",
      track: "rgba(212, 184, 150, 0.16)",
      value: "#9a7b4f",
    },
    rum_dark: {
      fill: "linear-gradient(90deg, #6b4c35 0%, #2a1f16 100%)",
      track: "rgba(42, 31, 22, 0.16)",
      value: "#4a3728",
    },
    tequila_blanco: {
      fill: "linear-gradient(90deg, #f5f5dc 0%, #e8e0c8 100%)",
      track: "rgba(232, 224, 200, 0.2)",
      value: "#9a9070",
    },
    tequila_reposado: {
      fill: "linear-gradient(90deg, #e8d48b 0%, #c9a227 100%)",
      track: "rgba(201, 162, 39, 0.14)",
      value: "#9a7b1a",
    },
    tequila_anejo: {
      fill: "linear-gradient(90deg, #d4a054 0%, #8b4513 100%)",
      track: "rgba(139, 69, 19, 0.12)",
      value: "#8b4513",
    },
    vodka: {
      fill: "linear-gradient(90deg, #eef4f8 0%, #c8dce8 100%)",
      track: "rgba(200, 220, 232, 0.2)",
      value: "#7a96a8",
    },
    sake: {
      fill: "linear-gradient(90deg, #f5f0dc 0%, #e8dfa8 100%)",
      track: "rgba(232, 223, 168, 0.18)",
      value: "#9a8f4a",
    },
    sake_nigori: {
      fill: "linear-gradient(90deg, #faf8f2 0%, #ece4d4 100%)",
      track: "rgba(236, 228, 212, 0.22)",
      value: "#9a9080",
    },
    absinthe: {
      fill: "linear-gradient(90deg, #8fbf6a 0%, #4a7c3f 100%)",
      track: "rgba(74, 124, 63, 0.14)",
      value: "#4a7c3f",
    },
    calvados: {
      fill: "linear-gradient(90deg, #e8c86a 0%, #b8860b 100%)",
      track: "rgba(184, 134, 11, 0.14)",
      value: "#b8860b",
    },
    vermouth_dry: {
      fill: "linear-gradient(90deg, #f0e8a8 0%, #d4c44a 100%)",
      track: "rgba(212, 196, 74, 0.14)",
      value: "#9a8f2a",
    },
    vermouth_sweet: {
      fill: "linear-gradient(90deg, #b85c4a 0%, #6b2a1f 100%)",
      track: "rgba(107, 42, 31, 0.14)",
      value: "#6b2a1f",
    },
  };

  var CYBER_PRODUCT_BAR_THEMES = {
    default: {
      fill: "linear-gradient(90deg, #00f0ff 0%, #0088aa 100%)",
      track: "rgba(0, 240, 255, 0.16)",
      value: "#00f0ff",
    },
    white_wine: {
      fill: "linear-gradient(90deg, #9ee8f4 0%, #00f0ff 100%)",
      track: "rgba(0, 240, 255, 0.14)",
      value: "#9ee8f4",
    },
    red_wine: {
      fill: "linear-gradient(90deg, #ff5cb0 0%, #ff2d95 100%)",
      track: "rgba(255, 45, 149, 0.18)",
      value: "#ff5cb0",
    },
    rose_wine: {
      fill: "linear-gradient(90deg, #ff8ec4 0%, #ff2d95 100%)",
      track: "rgba(255, 45, 149, 0.16)",
      value: "#ff8ec4",
    },
    sparkling: {
      fill: "linear-gradient(90deg, #00f0ff 0%, #00c4d4 100%)",
      track: "rgba(0, 240, 255, 0.18)",
      value: "#00f0ff",
    },
    sparkling_rose: {
      fill: "linear-gradient(90deg, #ff8ec4 0%, #00f0ff 100%)",
      track: "rgba(0, 240, 255, 0.16)",
      value: "#00f0ff",
    },
    orange_wine: {
      fill: "linear-gradient(90deg, #ffb347 0%, #ff2d95 100%)",
      track: "rgba(255, 45, 149, 0.14)",
      value: "#ffb347",
    },
    fortified: {
      fill: "linear-gradient(90deg, #ff5cb0 0%, #0088aa 100%)",
      track: "rgba(255, 45, 149, 0.16)",
      value: "#ff5cb0",
    },
    absinthe: {
      fill: "linear-gradient(90deg, #39ff14 0%, #00c4aa 100%)",
      track: "rgba(57, 255, 20, 0.14)",
      value: "#39ff14",
    },
  };

  function titleSuggestsBarFamousRedBordeaux(titleLower) {
    if (/haut[\s-]?brion\s+blanc/.test(titleLower)) return false;
    return (
      /haut[\s-]?brion|mission[\s-]?haut[\s-]?brion|lafite|latour|mouton(?:\s+rothschild)?|margaux|petrus|le[\s-]?pin|lynch[\s-]?bages|branaire|chasse[\s-]?spleen|lascombes|beychevelle|talbot|cheval[\s-]?blanc|ausone|angelus|figeac|pavie|conseillante|trotanoy|palmer|montrose|cos[\s-]?d[\s']?estournel|ducru[\s-]?beaucaillou|gruaud[\s-]?larose|pichon(?:[\s-]longueville)?|leoville|l[eé]oville[\s-]?las[\s-]?cases|l[eé]oville[\s-]?poyferr|l[eé]oville[\s-]?barton|st[\s-]?julien|st[\s-]?est[eè]phe|pauillac|pomerol|saint[\s-]?emilion|emilion|fronsac|canon[\s-]?fronsac|pessac|l[eé]ognan/.test(
        titleLower
      ) && !/\b(blanc|white)\s+wine\b/.test(titleLower)
    );
  }

  function titleSuggestsBarRedBurgundy(titleLower) {
    if (/\bcorton[\s-]charlemagne\b|\bbourgogne\s+blanc\b|\bblanc\s+de\s+noir\b/.test(titleLower)) {
      return false;
    }
    if (/\bchablis\b/.test(titleLower)) return false;
    if (
      /\b(meursault|puligny|chassagne)\b/.test(titleLower) &&
      !/\b(rouge|red)\b/.test(titleLower)
    ) {
      return false;
    }
    return (
      /\bechezeaux\b|\bgrands[\s-]echezeaux\b|\bgevrey\b|\bchambolle\b|\bvosne\b|\bnuits[\s-]saint[\s-]?georges\b|\bnuits[\s-]st[\s-]?georges\b|\bclos[\s-]de[\s-]vougeot\b|\bchambertin\b|\bmusigny\b|\bromanee\b|\brichebourg\b|\bla[\s-]tache\b|\bpommard\b|\bvolnay\b|\bfixin\b|\bmarsannay\b|\bsavigny[\s-]les[\s-]beaune\b|\bcorton\b(?![\s-]charlemagne)|\baloxe[\s-]corton\b|\bladoix[\s-]corton\b|\birancy\b|\bmercurey\b|\brully\b|\bmaranges\b/.test(
        titleLower
      ) && !/\b(blanc|white)\s+wine\b/.test(titleLower)
    );
  }

  function normalizeBarMatchText(text) {
    return String(text || "")
      .toLowerCase()
      .replace(/[\u2010\u2011\u2012\u2013\u2014\u2212\uFE58\uFE63\uFF0D]/g, "-");
  }

  function titleSuggestsBarWhiteWine(titleLower) {
    if (titleSuggestsBarFamousRedBordeaux(titleLower)) return false;
    if (
      /\b(dry\s+white|white\s+wine|blanc\s+de\s+blancs)\b/.test(titleLower) ||
      /乾白|干白|白酒/.test(titleLower)
    ) {
      return true;
    }
    if (
      /\b(?:silvaner|sylvaner|fermentaci[oó]n\s+lenta)\b/.test(titleLower) ||
      /\bximenez[\s-]+spinola\b/.test(titleLower) &&
        !/\b(?:px|pedro\s*xim[eé]nez|solera|viejo|muy\s+viejo|sherry|fino|amontillado|oloroso)\b/.test(
          titleLower
        )
    ) {
      return true;
    }
    if (
      /\b(?:pouilly[\s-]?fum[ée]|pouilly[\s-]?(?:vinzell|fuiss[ée]?|sur[\s-]?loire)|sancerre|muscadet|chablis|meursault|puligny|montrachet|chassagne|saint[\s-]?v[ée]ran|vir[ée][\s-]?cless[ée]|vire[\s-]?clesse|m[âa]con|macon|riesling|chardonnay|sauvignon\s+blanc|viognier|chenin|albari[nñ]o|pinot\s+grigio|pinot\s+gris|gew[üu]rz|gr[üu]ner|tonnerre)\b/.test(
        titleLower
      ) &&
      !/\b(rouge|red|noir)\b/.test(titleLower)
    ) {
      return true;
    }
    return (
      /\b(white|blanc|bianco|blanco|wei[sß]|weiss)\b/.test(titleLower) &&
      !/\b(red|rouge|tinto|rosso|noir|rot|rojo|dry\s+red)\b/.test(titleLower)
    );
  }

  function titleSuggestsBarRedWine(titleLower) {
    if (titleSuggestsBarSparklingChampagne(titleLower)) return false;
    if (
      /\b(dry\s+red|red\s+wine|claret|red\/rouge)\b/.test(titleLower) ||
      /乾紅|干红|紅酒|紅葡萄酒|红葡萄酒/.test(titleLower)
    ) {
      return true;
    }
    if (
      /\b(cabernet\s+sauvignon|cab\s+sauv|cabernet|shiraz|syrah|merlot|malbec|pinot\s+noir|nebbiolo|barolo|zinfandel|tempranillo|primitivo|sangiovese|chianti|brunello|amarone|grenache|garnacha|gamay)\b/.test(
        titleLower
      ) &&
      !/\bcabernet\s+franc\b/.test(titleLower)
    ) {
      return true;
    }
    if (
      /\b(?:beaujolais|fleurie|morgon|moulin[\s\-àa]+vent|brouilly|c[oô]te[\s-]?de[\s-]?brouilly|juli[eé]nas|ch[eé]nas|chiroubles|r[eé]gni[eé]|saint[\s\-]?amour)\b/.test(
        titleLower
      )
    ) {
      return true;
    }
    if (/\bpenfolds\s+bin\s+\d{2,3}\b/.test(titleLower)) return true;
    if (/\bcab\b/.test(titleLower) && !/\bcabernet\s+franc\b/.test(titleLower)) return true;
    return (
      /\b(red|rouge|noir|tinto|rosso)\b/.test(titleLower) &&
      !/\b(white|blanc|bianco|blanco|dry\s+white)\b/.test(titleLower)
    );
  }

  function titleSuggestsBarSparklingChampagne(titleLower) {
    if (
      /\b(champagne|prosecco|cava|cr[ée]mant|cremant|spumante|franciacorta|lambrusco|pet[\s-]?nat|p[ée]tillant|起泡|氣泡|香槟|香檳)\b/.test(
        titleLower
      )
    ) {
      return true;
    }
    return (
      /\b(dom[\s-]?p[eéè]rignon|mo[eë]t(?:[\s-]?(?:&|and|et)[\s-]?chandon)?|krug|bollinger|veuve[\s-]?clicquot|taittinger|ruinart|salon|pol[\s-]?roger|laurent[\s-]?perrier|louis[\s-]?roederer|cristal|armand[\s-]?de[\s-]?brignac|ace[\s-]?of[\s-]?spades|perrier[\s-]?jou[eë]t|perrier[\s-]?jouet|gosset|henriot|deutz|billecart(?:[\s-]?salmon)?|ayala|alfred[\s-]?gratien|jacquesson|pommery|mumm|nicolas[\s-]?feuillatte|piper[\s-]?heidsieck|charles[\s-]?heidsieck|champagne[\s-]?pannier|champagne[\s-]?collet|champagne[\s-]?thienot)\b/.test(
        titleLower
      ) ||
      /\b(blanc[\s-]?de[\s-]?blancs|blanc[\s-]?de[\s-]?noirs|extra[\s-]?brut|\bbrut\b)\b/.test(titleLower)
    );
  }

  function blobSuggestsBarSparklingChampagne(blob) {
    return (
      /champagne|prosecco|cava|sparkling|cr[ée]mant|cremant|起泡|氣泡|香槟|香檳|spumante|franciacorta|\bbrut\b|\bextra brut\b|\bblanc de blancs\b|dom[\s-]?p[eéè]rignon|mo[eë]t(?:[\s-]?(?:&|and|et)[\s-]?chandon)?|krug|bollinger|veuve[\s-]?clicquot|taittinger|ruinart|salon|pol[\s-]?roger|laurent[\s-]?perrier|louis[\s-]?roederer|cristal|perrier[\s-]?jou[eë]t|perrier[\s-]?jouet|billecart(?:[\s-]?salmon)?/.test(
        blob
      ) || /\b(champagne|sparkling|prosecco|cava)\b/.test(blob)
    );
  }

  function resolveSparklingBarCategory(blob) {
    return /ros[ée]|rose|pink|salmon|\brosato\b/.test(blob) ? "sparkling_rose" : "sparkling";
  }

  function blobSuggestsBarRedWine(blob) {
    if (blobSuggestsBarSparklingChampagne(blob)) return false;
    return /pinot noir|cabernet|merlot|shiraz|syrah|malbec|nebbiolo|barolo|sangiovese|chianti|brunello|amarone|zinfandel|primitivo|tempranillo|rioja|gevrey|echezeaux|grands[\s-]echezeaux|chambolle|vosne|nuits|clos[\s-]de[\s-]vougeot|chambertin|musigny|romanee|richebourg|pommard|volnay|pomerol|emilion|margaux|pauillac|bouard|beaujolais|gamay|fleurie|morgon|moulin[\s\-àa]+vent|brouilly|juli[eé]nas|ch[eé]nas|chiroubles|r[eé]gni[eé]|saint[\s\-]?amour|black fruit|dark berry|silky tannin|red wine|紅酒|黑皮諾|赤霞珠|西拉|設拉子|\bred\b|\brouge\b|\bnoir\b|\btinto\b|\brosso\b|red\/rouge|penfolds\s+bin\s+\d{2,3}/.test(
      blob
    );
  }

  function blobSuggestsBarWhiteWine(blob) {
    if (blobSuggestsBarRedWine(blob)) return false;
    if (/\bcabernet\s+sauvignon\b/.test(blob)) return false;
    if (/\bcabernet\b(?!\s*franc)/.test(blob)) return false;
    // Use \bstraw\b so "strawberries" (red Gamay note) is not treated as pale-straw white color.
    return /chardonnay|sauvignon\s+blanc|riesling|chablis|white burg|bourgogne blanc|blanc de blancs|viognier|chenin\s+blanc|semillon|pinot grigio|pinot gris|albariño|albarino|gew[üu]rz|muscat blanc|gr[üu]ner|silvaner|sylvaner|fermentaci[oó]n\s+lenta|torrontes|white wine|白酒|霞多|長相思|雷司令|pale gold|\bstraw\b|yellow-green|pouilly[\s-]?(?:vinzell|fuiss|sur[\s-]?loire|fum[ée])|pouilly[\s-]?fum[ée]|saint[\s-]?v[ée]ran|vir[ée][\s-]?cless[ée]|vire[\s-]?clesse|macon|m[âa]con|maconnais|meursault|puligny|montrachet|chassagne|auxey[\s-]duresses|corton[\s-]charlemagne|pernand|sancerre|muscadet|anjou blanc|vouvray sec|montagny|givry blanc/.test(
      blob
    );
  }

  function detectProductBarCategory(wine) {
    var pt = normalizeBarMatchText(String((wine && wine.product_type) || "").replace(/[_-]+/g, " "));
    var title = String((wine && wine.title) || "");
    var notes = String((wine && wine.tasting_notes) || "");
    var titleLower = normalizeBarMatchText(title);
    var blob = normalizeBarMatchText(title + " " + notes + " " + pt);
    var titlePtBlob = normalizeBarMatchText(title + " " + pt);
    var sku = String((wine && wine.sku) || "").trim().toUpperCase();
    var explicitCategory = String(
      (wine && (wine.bar_chart_category || wine.product_bar_category)) || ""
    ).trim();
    if (explicitCategory === "champagne") explicitCategory = "sparkling";
    if (explicitCategory && PRODUCT_BAR_THEMES[explicitCategory]) return explicitCategory;

    if (titleSuggestsBarSparklingChampagne(titleLower)) {
      return resolveSparklingBarCategory(blob);
    }

    if (/\b(champagne|sparkling|prosecco|cava)\b/.test(pt)) {
      return resolveSparklingBarCategory(blob);
    }

    // SENS item codes encode colour in the letter before the digits (e.g. FRW0269 white, FRR1689 red).
    if (/^(?:FR|IT|ES|DE|AT|AU|NZ|US|CL|AR|ZA|PT|GR|GB|HK)W\d/.test(sku)) {
      return "white_wine";
    }
    if (/^(?:FR|IT|ES|DE|AT|AU|NZ|US|CL|AR|ZA|PT|GR|GB|HK)R\d/.test(sku)) {
      return "red_wine";
    }

    var tagsBlob = "";
    if (wine && wine.tags) {
      tagsBlob = Array.isArray(wine.tags) ? wine.tags.join(" ").toLowerCase() : String(wine.tags).toLowerCase();
      if (/\bchampagne\b/.test(tagsBlob)) return resolveSparklingBarCategory(tagsBlob);
      if (/\bsparklings?\b/.test(tagsBlob)) return resolveSparklingBarCategory(tagsBlob);
      if (/\bred wines?\b/.test(tagsBlob)) return "red_wine";
    }

    if (titleSuggestsBarFamousRedBordeaux(titleLower)) return "red_wine";
    if (titleSuggestsBarRedBurgundy(titleLower)) return "red_wine";
    if (titleSuggestsBarRedWine(titleLower)) return "red_wine";
    if (titleSuggestsBarWhiteWine(titleLower)) return "white_wine";

    if (wine && wine.tags) {
      if (/\bwhite wines?\b/.test(tagsBlob)) return "white_wine";
      if (/\brose wines?|ros[ée] wines?\b/.test(tagsBlob)) return "rose_wine";
    }

    if (/\bbourbon\b/.test(blob)) return "bourbon";
    if (/\b(cognac|xo|vsop|xxo)\b/.test(blob) && !/armagnac/.test(blob)) return "cognac";
    if (/armagnac/.test(blob)) return "armagnac";
    if (/\bgin\b/.test(blob)) return "gin";
    if (/vodka/.test(blob)) return "vodka";
    if (/absinthe/.test(blob)) return "absinthe";
    if (/calvados/.test(blob)) return "calvados";
    if (/vermouth|lillet|aperitif wine/.test(blob)) {
      return /sweet|rosso|rouge|red|bianco rosso/.test(blob) ? "vermouth_sweet" : "vermouth_dry";
    }
    if (/rum/.test(blob)) return /dark|spiced|black|navy/.test(blob) ? "rum_dark" : "rum";
    if (/tequila|mezcal/.test(blob)) {
      if (/añejo|anejo|extra añejo|extra anejo/.test(blob)) return "tequila_anejo";
      if (/reposado/.test(blob)) return "tequila_reposado";
      return "tequila_blanco";
    }
    if (/sake|清酒|大吟釀|純米/.test(blob)) return /nigori|cloudy|濁/.test(blob) ? "sake_nigori" : "sake";
    if (/whisky|whiskey|scotch|single malt|blended malt|rye whiskey|malt whisky/.test(blob)) return "whisky";

    if (/orange wine|skin.contact|skin contact|skin-contact/.test(blob)) return "orange_wine";
    if (
      /sherry|port|madeira|fortified|tawny|fino|marsala|muscat de beaumes|vin doux|pedro\s*xim[eé]nez|\bpx\b/.test(
        blob
      ) &&
      !/\bfermentaci[oó]n\s+lenta\b/.test(titleLower)
    ) {
      return "fortified";
    }
    if (
      /champagne|prosecco|cava|sparkling|cr[ée]mant|cremant|起泡|氣泡|香槟|香檳|spumante|franciacorta|\bbrut\b|\bextra brut\b|\bblanc de blancs\b/.test(
        blob
      ) ||
      /\b(champagne|sparkling|prosecco|cava)\b/.test(pt) ||
      blobSuggestsBarSparklingChampagne(blob)
    ) {
      return resolveSparklingBarCategory(blob);
    }
    if (/ros[ée]|rosé|rose wine|粉紅|桃红|桃紅|\brosato\b/.test(blob)) return "rose_wine";

    if (/\bwhite wine\b/.test(pt) || pt === "white") return "white_wine";
    if (/\bred wine\b/.test(pt) || pt === "red") return "red_wine";
    if (/sparkling/.test(pt)) return /ros|rose|pink/.test(blob) ? "sparkling_rose" : "sparkling";
    if (/fortified|port|sherry/.test(pt)) return "fortified";
    if (/whisky|whiskey|spirit|spirits/.test(pt)) return "whisky";

    if (
      /bouard|pomerol|emilion|margaux|pauillac|saint[\s-]?julien|saint[\s-]?est[eè]phe|saint[\s-]?emilion|lalande[\s-]?de[\s-]?pomerol|castillon|c[oô]tes de bordeaux|graves|m[eé]doc|haut[\s-]?m[eé]doc|haut[\s-]?brion|mission[\s-]?haut[\s-]?brion|pessac|l[eé]ognan|lafite|latour|mouton|petrus|le[\s-]?pin|lynch[\s-]?bages|cheval[\s-]?blanc|fronsac|canon[\s-]?fronsac|chateauneuf|hermitage|c[oô]tes du rh[oô]ne|bandol|barossa|napa valley|left bank|right bank|bordeaux rouge|claret/.test(
        titlePtBlob
      )
    ) {
      return "red_wine";
    }

    if (
      /\b(white|blanc|bianco|blanco|wei[sß]|weiss)\b/.test(titlePtBlob) &&
      !/\b(red|rouge|tinto|rosso|noir|rot|rojo)\b/.test(titleLower)
    ) {
      return "white_wine";
    }

    if (blobSuggestsBarRedWine(blob)) {
      return "red_wine";
    }

    if (blobSuggestsBarWhiteWine(blob)) {
      return "white_wine";
    }

    if (
      /granny smith|lemon rind|lemon zest|white flower|white peach|gooseberry|cut grass|citrus zest|green apple|pale straw|straw yellow|white florals|minerally finish/.test(
        blob
      ) &&
      !titleSuggestsBarFamousRedBordeaux(titleLower) &&
      !blobSuggestsBarRedWine(blob)
    ) {
      return "white_wine";
    }

    return "red_wine";
  }

  function resolveProductBarThemeForCategory(category) {
    if (chatTheme === "cyber") {
      return CYBER_PRODUCT_BAR_THEMES[category] || CYBER_PRODUCT_BAR_THEMES.default;
    }
    if (chatTheme === "modern") {
      return MODERN_PRODUCT_BAR_THEMES[category] || MODERN_PRODUCT_BAR_THEMES.red_wine;
    }
    return PRODUCT_BAR_THEMES[category] || PRODUCT_BAR_THEMES.red_wine;
  }

  function resolveProductBarTheme(wine) {
    return resolveProductBarThemeForCategory(detectProductBarCategory(wine));
  }

  function applyProductBarThemeToElement(barsEl, category) {
    if (!barsEl) return;
    var theme = resolveProductBarThemeForCategory(category);
    barsEl.style.setProperty("--wine-bar-fill", theme.fill);
    barsEl.style.setProperty("--wine-bar-track", theme.track);
    barsEl.style.setProperty("--wine-bar-value", theme.value);
  }

  function syncProductBarThemes() {
    if (!messagesEl) return;
    messagesEl.querySelectorAll(".sens-ai-wine-bars[data-bar-theme]").forEach(function (barsEl) {
      applyProductBarThemeToElement(barsEl, barsEl.getAttribute("data-bar-theme") || "red_wine");
    });
  }

  function profileBarWidth(value) {
    var score = clampProfileScore(value);
    var amplified = clampProfileScore(
      PROFILE_BAR_BASELINE + (score - PROFILE_BAR_BASELINE) * PROFILE_BAR_CONTRAST
    );
    return Math.max(6, Math.min(100, Math.round(((amplified - 1.8) / 3.1) * 100)));
  }

  function buildWineProfileBarsHtml(profile, wine) {
    var category = detectProductBarCategory(wine || {});
    var theme = resolveProductBarTheme(wine || {});
    var parts = [
      '<div class="sens-ai-wine-bars" data-bar-theme="' +
        escapeHtml(category) +
        '" style="--wine-bar-fill:' +
        theme.fill +
        ";--wine-bar-track:" +
        theme.track +
        ";--wine-bar-value:" +
        theme.value +
        '" role="img" aria-label="Tasting profile chart">',
    ];
    for (var i = 0; i < profile.length; i++) {
      var dim = profile[i];
      var width = profileBarWidth(dim.value);
      parts.push(
        '<div class="sens-ai-wine-bar">' +
          '<div class="sens-ai-wine-bar__head">' +
          '<span class="sens-ai-wine-bar__label">' +
          escapeHtml(dim.label) +
          "</span>" +
          '<span class="sens-ai-wine-bar__value">' +
          dim.value.toFixed(1) +
          "</span>" +
          "</div>" +
          '<div class="sens-ai-wine-bar__track">' +
          '<div class="sens-ai-wine-bar__fill" style="width:' +
          width +
          '%"></div>' +
          "</div>" +
          "</div>"
      );
    }
    parts.push("</div>");
    return parts.join("");
  }

  function buildWineProfileHtml(wine, cardComment) {
    var profile = resolveWineProfile(wine, cardComment);
    var showRadar = shouldShowTastingRadar(wine, profile);
    var critics = String(wine.critic_scores || "").trim();
    if (!critics && wine.title) critics = criticScoresFromTitle(wine.title);

    var html = '<div class="sens-ai-wine-profile">';
    if (showRadar) {
      html += '<p class="sens-ai-wine-profile__heading">Tasting profile · 品飲印象</p>';
      html += '<div class="sens-ai-wine-bars-wrap">' + buildWineProfileBarsHtml(profile, wine) + "</div>";
    }
    html += '<div class="sens-ai-wine-critics">';
    html += '<span class="sens-ai-wine-critics__label">Wine Critics</span>';
    if (critics) {
      html +=
        '<span class="sens-ai-wine-critics__badge">' + escapeHtml(critics) + "</span>";
    } else {
      html += '<span class="sens-ai-wine-critics__badge sens-ai-wine-critics__badge--na">N/A</span>';
    }
    html += "</div></div>";
    return html;
  }

  function sanitizeCardReason(text) {
    var cleaned = stripWineMarkdownFromComment(text);
    cleaned = stripMalformedBudgetPhrases(cleaned);
    if (!cleaned) return "";
    if (isBudgetOnlyComment(cleaned)) return "";
    var genericPrefixes = [
      /^符合你今次搜尋的風格與條件[。.\s]*/u,
      /^紅酒風格符合你今次搜尋[。.\s]*/u,
      /^白酒風格符合你今次搜尋[。.\s]*/u,
      /^Matches the style and criteria for your search[.:\s]*/i,
      /^Red wine style matches what you asked for[.:\s]*/i,
      /^White wine style matches what you asked for[.:\s]*/i,
      /^Structured (?:Cabernet|Bordeaux|Barolo|Shiraz)\b.*$/i,
      /^Classic Bordeaux profile you asked for[.:\s]*/i,
      /^Shiraz fruit and spice as requested[.:\s]*/i,
      /^Chardonnay body matches your search[.:\s]*/i,
      /^Riesling's acidity and fruit stand out[.:\s]*/i,
      /^Silky, gentle Pinot Noir style[.:\s]*/i,
      /^Sparkling freshness fits your search[.:\s]*/i,
      /^At (?:HK)?\$[\d,]+,?\s*within your budget and fits your search[.:\s]*/i,
      /^within your budget and fits your search[.:\s]*/i,
      /^(?:HK)?\$[\d,]+[，,]?\s*在你預算之內[，,]?\s*風格貼合今次搜尋[。.\s]*/u,
    ];
    for (var i = 0; i < genericPrefixes.length; i++) {
      cleaned = cleaned.replace(genericPrefixes[i], "");
    }
    cleaned = cleaned.trim();
    if (isBudgetOnlyComment(cleaned)) return "";
    if (isGenericCatalogComment(cleaned)) return "";
    return cleaned;
  }

  function wineItemCode(wine) {
    if (!wine) return "";
    return String(wine.sku || wine.item_code || "").trim();
  }

  function buildWineItemCodeHtml(wine) {
    var code = wineItemCode(wine);
    if (!code) return "";
    return (
      '<p class="sens-ai-wine-item-code">' +
      '<span class="sens-ai-wine-item-code__label">Item code</span> ' +
      escapeHtml(code) +
      "</p>"
    );
  }

  function buildWineMetaRowHtml(wine) {
    var priceHtml = buildWinePriceHtml(wine);
    var itemCodeHtml = buildWineItemCodeHtml(wine);
    if (!priceHtml && !itemCodeHtml) return "";
    return priceHtml + itemCodeHtml;
  }

  function isHiddenWineExportCommand(message) {
    var text = String(message || "").trim().toLowerCase();
    return (
      text === "/export" ||
      text === "/sheet" ||
      text === "/csv" ||
      text === "export wines" ||
      text === "export sheet"
    );
  }

  function csvEscapeCell(value) {
    var text = String(value == null ? "" : value);
    if (/[",\n\r]/.test(text)) {
      return '"' + text.replace(/"/g, '""') + '"';
    }
    return text;
  }

  function wineExportPriceValue(wine) {
    var sale = wineSalePriceValue(wine);
    return sale != null ? sale : "";
  }

  function buildShownWinesCsv(wines) {
    var lines = ["Item code,Wine,Price (HKD)"];
    (wines || []).forEach(function (wine) {
      lines.push(
        [
          csvEscapeCell(wineItemCode(wine)),
          csvEscapeCell(cleanDisplayText(wine && wine.title ? wine.title : "")),
          csvEscapeCell(wineExportPriceValue(wine)),
        ].join(",")
      );
    });
    return lines.join("\r\n") + "\r\n";
  }

  function downloadCsvFile(filename, csvText) {
    var blob = new Blob(["\uFEFF" + csvText], { type: "text/csv;charset=utf-8;" });
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 1000);
  }

  function exportShownWinesSpreadsheet() {
    var wines = Array.isArray(lastWines) ? lastWines.slice() : [];
    if (!wines.length) {
      showToast("No wine results to export yet");
      return false;
    }
    var stamp = new Date();
    var yyyy = stamp.getFullYear();
    var mm = String(stamp.getMonth() + 1).padStart(2, "0");
    var dd = String(stamp.getDate()).padStart(2, "0");
    var filename = "mirai-wines-" + yyyy + "-" + mm + "-" + dd + ".csv";
    downloadCsvFile(filename, buildShownWinesCsv(wines));
    showToast("Exported " + wines.length + " wine" + (wines.length === 1 ? "" : "s"));
    return true;
  }

  function buildVintagePickerHtml(wine) {
    var options = wine && wine.variant_options;
    if (!options || options.length < 2) return "";
    var html =
      '<div class="sens-ai-vintage-picker" role="group" aria-label="Choose vintage · 揀年份">';
    options.forEach(function (opt) {
      if (!opt || !opt.variant_id) return;
      var label = escapeHtml(String(opt.label || "Vintage"));
      var price = opt.price != null ? formatPrice(opt.price) : "";
      html +=
        '<button type="button" class="sens-ai-vintage-picker__btn sens-ai-btn sens-ai-btn--cart" data-variant-id="' +
        escapeHtml(String(opt.variant_id)) +
        '"><span class="sens-ai-vintage-picker__label">' +
        label +
        "</span>";
      if (price) {
        html += '<span class="sens-ai-vintage-picker__price">' + price + "</span>";
      }
      html += "</button>";
    });
    html += "</div>";
    return html;
  }

  function buildWineGridHtml(wines, wineComments) {
    if (!wines || !wines.length) return "";
    wineComments = wineComments || {};
    var multi = wines.length > 1;
    var carouselClass = "sens-ai-wine-carousel" + (multi ? "" : " is-single");
    var html =
      '<div class="sens-ai-msg__wines"><p class="sens-ai-msg__wines-label">From our cellar · 酒窖精選</p>' +
      '<div class="' +
      carouselClass +
      '" data-wine-count="' +
      wines.length +
      '"><div class="sens-ai-wine-grid">';
    wines.forEach(function (wine, cardIndex) {
      var pickNum = wine && wine.pick_index != null ? Number(wine.pick_index) : cardIndex + 1;
      if (!Number.isFinite(pickNum) || pickNum < 1) pickNum = cardIndex + 1;
      var title = escapeHtml(cleanDisplayText(wine.title || "Wine"));
      var url = wineProductUrl(wine);
      var image = wine.image || "";
      var variantId = wineVariantId(wine);
      var commentText = cardCommentPreviewFull(wine, wineComments[wine.title]);
      var preview = commentText.preview;
      var full = commentText.full;
      var isLinkedCard = url && url !== "#";
      var cardLinkAttrs = isLinkedCard
        ? ' data-product-url="' +
          escapeHtml(url) +
          '" role="link" tabindex="0" aria-label="View ' +
          title +
          '"'
        : "";
      html +=
        '<article class="sens-ai-wine-card' +
        (isLinkedCard ? " sens-ai-wine-card--link" : "") +
        '" data-pick-index="' +
        escapeHtml(String(pickNum)) +
        '"' +
        cardLinkAttrs +
        '><span class="sens-ai-wine-pick-num" aria-label="Pick ' +
        escapeHtml(String(pickNum)) +
        '">' +
        escapeHtml(String(pickNum)) +
        "</span><div class=\"sens-ai-wine-img-wrap\">";
      if (image) {
        html += '<img class="sens-ai-wine-img" src="' + escapeHtml(image) + '" alt="' + title + '" loading="lazy">';
      } else {
        html += '<svg class="sens-ai-wine-img sens-ai-wine-img--placeholder" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M8 2h8l1 7c0 3.5-2.2 6.5-5 7.6V22H12v-5.4C9.2 15.5 7 12.5 7 9L8 2z"/></svg>';
      }
      html += '</div><div class="sens-ai-wine-body"><h3 class="sens-ai-wine-title"><a href="' + escapeHtml(url) + '">' + title + "</a></h3>";
      html += buildWineMetaRowHtml(wine);
      html += buildWineCardCommentsHtml(url, preview, full);
      html += buildWineProfileHtml(wine, full || preview);
      html += '<div class="sens-ai-wine-actions">';
      var vintageHtml = buildVintagePickerHtml(wine);
      if (vintageHtml) {
        html += vintageHtml;
      } else if (variantId) {
        html += '<button type="button" class="sens-ai-btn sens-ai-btn--cart" data-variant-id="' + escapeHtml(String(variantId)) + '">Add</button>';
      } else {
        html += '<button type="button" class="sens-ai-btn sens-ai-btn--cart" disabled>Add</button>';
      }
      html += '<a class="sens-ai-btn sens-ai-btn--link" href="' + escapeHtml(url) + '">View</a></div></div></article>';
    });
    html += "</div>";
    if (multi) {
      html +=
        '<button type="button" class="sens-ai-wine-scroll-hint" aria-label="More wines · 滑動睇更多">' +
        '<span class="sens-ai-wine-scroll-hint__chevron" aria-hidden="true"></span></button>';
    }
    html += "</div>";
    if (multi) {
      html += '<p class="sens-ai-wine-scroll-caption">Swipe for more · 左右滑動睇更多</p>';
    }
    html += "</div>";
    return html;
  }

  function scrollWineCarouselToNext(grid) {
    if (!grid) return;
    var cards = grid.querySelectorAll(".sens-ai-wine-card");
    if (!cards.length) return;
    var gridLeft = grid.getBoundingClientRect().left;
    var nextCard = null;
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getBoundingClientRect().left > gridLeft + 10) {
        nextCard = cards[i];
        break;
      }
    }
    if (!nextCard) nextCard = cards[cards.length - 1];
    if (nextCard.scrollIntoView) {
      nextCard.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
    } else {
      grid.scrollLeft = nextCard.offsetLeft;
    }
  }

  function setupWineCarouselHints(root) {
    if (!root) return;
    root.querySelectorAll(".sens-ai-wine-carousel").forEach(function (carousel) {
      if (carousel.dataset.hintReady === "1") return;
      carousel.dataset.hintReady = "1";
      var grid = carousel.querySelector(".sens-ai-wine-grid");
      if (!grid) return;

      function updateHint() {
        var overflow = grid.scrollWidth > grid.clientWidth + 6;
        var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 8;
        carousel.classList.toggle("has-overflow", overflow && !atEnd);
        carousel.classList.toggle("is-at-end", !overflow || atEnd);
      }

      grid.addEventListener("scroll", updateHint, { passive: true });
      window.addEventListener("resize", updateHint);
      updateHint();
      window.setTimeout(updateHint, 120);
    });
  }

  function appendBotReply(text, wines, userMessage, replyMeta) {
    var meta = replyMeta || {};
    var prepared = prepareReplyAndWines(text, wines, userMessage, meta.mode || "");
    var meta = replyMeta || {};
    var cardWines = prepared.cardWines;
    var showAboutHero = shouldShowAboutSensHero(meta, userMessage, prepared.bubbleText);
    var showReplyBubble = shouldShowReplyBubbleWithWineCards(
      meta,
      cardWines,
      userMessage,
      prepared.bubbleText
    );
    var wrap = document.createElement("div");
    wrap.className = "sens-ai-msg sens-ai-msg--bot";
    if (cardWines && cardWines.length) wrap.className += " sens-ai-msg--with-wines";
    if (!showReplyBubble && cardWines && cardWines.length) {
      wrap.classList.add("sens-ai-msg--cards-only");
    }
    if (showAboutHero) wrap.classList.add("sens-ai-msg--about-sens");
    wrap.appendChild(createButlerSender());
    var stack = document.createElement("div");
    stack.className = "sens-ai-msg__stack";
    if ((showReplyBubble && String(prepared.bubbleText || "").trim()) || showAboutHero) {
      var bubble = document.createElement("div");
      bubble.className = "sens-ai-msg__bubble";
      var heroHtml = showAboutHero ? buildAboutSensHeroHtml(meta.hero_image_url) : "";
      var bodyHtml = formatReplyWithReadMore(prepared.bubbleText, cardWines, prepared.wineComments);
      prepareBotBubbleForCyberReveal(bubble);
      if (showAboutHero) {
        bubble.classList.add("sens-ai-msg__bubble--about-sens");
        bubble.innerHTML = heroHtml + '<div class="sens-ai-about-body">' + bodyHtml + "</div>";
      } else {
        bubble.innerHTML = bodyHtml;
      }
      if (cardWines && cardWines.length) {
        try {
          bubble.dataset.replyWines = JSON.stringify(cardWines);
        } catch (e) {}
      }
      stack.appendChild(bubble);
      if (cardWines && cardWines.length) {
        stack.insertAdjacentHTML("beforeend", buildWineGridHtml(cardWines, prepared.wineComments));
      }
      wrap.appendChild(stack);
      messagesEl.appendChild(wrap);
      finalizeBotBubble(bubble);
      attachAboutHeroImageHandlers(bubble);
    } else if (cardWines && cardWines.length) {
      stack.insertAdjacentHTML("beforeend", buildWineGridHtml(cardWines, prepared.wineComments));
      wrap.appendChild(stack);
      messagesEl.appendChild(wrap);
    } else {
      var emptyBubble = document.createElement("div");
      emptyBubble.className = "sens-ai-msg__bubble";
      emptyBubble.innerHTML = formatReplyWithReadMore(prepared.bubbleText, [], prepared.wineComments);
      prepareBotBubbleForCyberReveal(emptyBubble);
      stack.appendChild(emptyBubble);
      wrap.appendChild(stack);
      messagesEl.appendChild(wrap);
      finalizeBotBubble(emptyBubble);
    }
    setupWineCarouselHints(wrap);
    scrollMessageIntoView(wrap);
    saveChatSession();
    return wrap;
  }

  function isInteractiveCardTarget(target) {
    return !!(
      target &&
      target.closest(
        "a, button, input, select, textarea, label, .sens-ai-read-more__btn, .sens-ai-wine-scroll-hint"
      )
    );
  }

  function openWineCardProduct(card) {
    var url = card && String(card.getAttribute("data-product-url") || "").trim();
    if (!url || url === "#") return;
    persistOpenForNavigation();
    window.location.href = url;
  }

  function appendMessage(role, text, extraClass) {
    return appendUserOrBotMessage(role, text, extraClass, "");
  }

  function appendUserOrBotMessage(role, text, extraClass, imagePreviewUrl) {
    var wrap = document.createElement("div");
    wrap.className = "sens-ai-msg sens-ai-msg--" + (role === "user" ? "user" : "bot");
    if (extraClass) wrap.className += " " + extraClass;
    if (role !== "user") {
      wrap.appendChild(createButlerSender());
    }
    var bubble = document.createElement("div");
    bubble.className = "sens-ai-msg__bubble";
    if (role === "user") {
      if (imagePreviewUrl) {
        var photo = document.createElement("img");
        photo.className = "sens-ai-msg__photo";
        photo.alt = "";
        photo.setAttribute("role", "presentation");
        photo.src = imagePreviewUrl;
        bubble.appendChild(photo);
      }
      if (text) {
        var userText = document.createElement("div");
        userText.className = "sens-ai-msg__text";
        userText.textContent = text;
        bubble.appendChild(userText);
      }
    } else if (extraClass === "sens-ai-msg--loading") {
      bubble.innerHTML = formatReply(text, []);
    } else {
      prepareBotBubbleForCyberReveal(bubble);
      bubble.innerHTML = formatReplyWithReadMore(text);
    }
    wrap.appendChild(bubble);
    messagesEl.appendChild(wrap);
    if (role === "bot" && extraClass !== "sens-ai-msg--loading") {
      finalizeBotBubble(bubble);
    }
    scrollMessages();
    if (!extraClass || extraClass !== "sens-ai-msg--loading") {
      saveChatSession();
    }
    return wrap;
  }

  function revokeObjectUrl(url) {
    if (url && String(url).indexOf("blob:") === 0) {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {}
    }
  }

  function base64ToBlob(base64, mediaType) {
    var bin = atob(base64);
    var len = bin.length;
    var arr = new Uint8Array(len);
    for (var i = 0; i < len; i++) arr[i] = bin.charCodeAt(i);
    return new Blob([arr], { type: mediaType || "image/jpeg" });
  }

  function buildPhotoPayload(previewUrl, base64, mediaType, sourceFile) {
    return {
      previewUrl: previewUrl,
      base64: base64,
      mediaType: mediaType || "image/jpeg",
      sourceFile: sourceFile || null,
    };
  }

  function normalizeImageMediaType(file) {
    var type = String((file && file.type) || "").toLowerCase();
    if (type === "image/jpg") return "image/jpeg";
    if (type) return type;
    var name = String((file && file.name) || "").toLowerCase();
    if (/\.(jpe?g)$/.test(name)) return "image/jpeg";
    if (/\.png$/.test(name)) return "image/png";
    if (/\.webp$/.test(name)) return "image/webp";
    if (/\.heic$/.test(name)) return "image/heic";
    if (/\.heif$/.test(name)) return "image/heif";
    return "image/jpeg";
  }

  function isSupportedUploadType(mediaType) {
    return /^(image\/jpeg|image\/png|image\/webp)$/.test(mediaType || "");
  }

  function clonePreviewUrl(payload) {
    if (!payload) return "";
    if (payload.sourceFile) return URL.createObjectURL(payload.sourceFile);
    if (payload.base64) {
      return URL.createObjectURL(base64ToBlob(payload.base64, payload.mediaType));
    }
    return payload.previewUrl || "";
  }

  function setAttachMenuOpen(open) {
    attachMenuOpen = !!open;
    if (attachMenuEl) attachMenuEl.hidden = !attachMenuOpen;
    if (attachBtnEl) {
      attachBtnEl.setAttribute("aria-expanded", attachMenuOpen ? "true" : "false");
      attachBtnEl.setAttribute("aria-label", attachMenuOpen ? "Close menu" : "Add attachment");
      var icon = attachBtnEl.querySelector(".sens-ai-composer__attach-icon");
      if (icon) icon.textContent = attachMenuOpen ? "×" : "+";
    }
  }

  function closeAttachMenu() {
    setAttachMenuOpen(false);
  }

  function toggleAttachMenu() {
    setAttachMenuOpen(!attachMenuOpen);
  }

  function syncPhotoPreviewChrome(hasPhoto) {
    /* preview sits above the pill; no layout class needed */
  }

  function openPhotoPicker(useCamera) {
    if (!photoInputEl || busy) return;
    photoInputEl.value = "";
    if (useCamera) {
      photoInputEl.setAttribute("capture", "environment");
    } else {
      photoInputEl.removeAttribute("capture");
    }
    photoInputEl.click();
  }

  function handlePhotoFileSelected(file) {
    if (!file) return;
    if (!String(file.type || "").toLowerCase().match(/^image\//)) {
      showToast("Please choose a photo (JPEG, PNG, or WebP).");
      if (photoInputEl) photoInputEl.value = "";
      return;
    }
    processImageFile(file)
      .then(function (payload) {
        setPendingPhoto(payload);
      })
      .catch(function (err) {
        var code = err && err.message ? String(err.message) : "";
        if (code === "heic" || code === "unsupported_type") {
          showToast("This photo format isn't supported — pick JPEG/PNG from your album, or use Most Compatible on iPhone.");
        } else {
          showToast("Could not read that photo — try another image.");
        }
        clearPendingPhoto();
      });
  }

  function clearPendingPhoto() {
    if (pendingPhoto && pendingPhoto.previewUrl) {
      revokeObjectUrl(pendingPhoto.previewUrl);
    }
    pendingPhoto = null;
    if (photoPreviewEl) photoPreviewEl.hidden = true;
    if (photoPreviewImgEl) {
      photoPreviewImgEl.onerror = null;
      photoPreviewImgEl.removeAttribute("src");
    }
    if (photoInputEl) {
      photoInputEl.value = "";
      photoInputEl.removeAttribute("capture");
    }
    syncPhotoPreviewChrome(false);
  }

  function attachPreviewFallback(previewImg, payload) {
    if (!previewImg || !payload) return;
    previewImg.onerror = function () {
      previewImg.onerror = null;
      if (payload.sourceFile) {
        revokeObjectUrl(payload.previewUrl);
        payload.previewUrl = URL.createObjectURL(payload.sourceFile);
        previewImg.src = payload.previewUrl;
      }
    };
  }

  function setPendingPhoto(payload) {
    if (pendingPhoto && pendingPhoto.previewUrl) {
      revokeObjectUrl(pendingPhoto.previewUrl);
    }
    pendingPhoto = payload;
    if (photoPreviewEl && photoPreviewImgEl && payload && payload.previewUrl) {
      attachPreviewFallback(photoPreviewImgEl, payload);
      photoPreviewImgEl.src = payload.previewUrl;
      photoPreviewEl.hidden = false;
      syncPhotoPreviewChrome(true);
    }
  }

  function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function compressChatImage(file) {
    return readFileAsDataUrl(file).then(function (dataUrl) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          var w = img.width;
          var h = img.height;
          var max = MAX_IMAGE_DIM;
          if (w > max || h > max) {
            if (w >= h) {
              h = Math.round(h * (max / w));
              w = max;
            } else {
              w = Math.round(w * (max / h));
              h = max;
            }
          }
          var canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext("2d");
          if (!ctx) {
            reject(new Error("Could not process photo"));
            return;
          }
          ctx.drawImage(img, 0, 0, w, h);
          var out = canvas.toDataURL("image/jpeg", JPEG_QUALITY);
          var base64 = out.split(",")[1] || "";
          var blob = base64ToBlob(base64, "image/jpeg");
          resolve(buildPhotoPayload(URL.createObjectURL(blob), base64, "image/jpeg", file));
        };
        img.onerror = function () {
          reject(new Error("Could not read photo"));
        };
        img.src = dataUrl;
      });
    });
  }

  function fileToPhotoPayload(file) {
    var mediaType = normalizeImageMediaType(file);
    if (!isSupportedUploadType(mediaType)) {
      return Promise.reject(new Error("unsupported_type"));
    }
    return readFileAsDataUrl(file).then(function (dataUrl) {
      var base64 = String(dataUrl).split(",")[1] || "";
      return buildPhotoPayload(URL.createObjectURL(file), base64, mediaType, file);
    });
  }

  function processImageFile(file) {
    var mediaType = normalizeImageMediaType(file);
    if (mediaType === "image/heic" || mediaType === "image/heif") {
      return Promise.reject(new Error("heic"));
    }
    var previewUrl = URL.createObjectURL(file);
    return compressChatImage(file)
      .then(function (payload) {
        payload.sourceFile = file;
        revokeObjectUrl(payload.previewUrl);
        payload.previewUrl = previewUrl;
        return payload;
      })
      .catch(function () {
        return fileToPhotoPayload(file).then(function (payload) {
          revokeObjectUrl(payload.previewUrl);
          payload.previewUrl = previewUrl;
          return payload;
        });
      });
  }

  function historyTextForTurn(message, hasPhoto) {
    var text = (message || "").trim();
    if (text) return text;
    if (hasPhoto) return "[Photo] What wine pairs with this food?";
    return text;
  }

  function shouldUseStreaming(photoPayload) {
    return CONFIG.streamingEnabled && CONFIG.streamApiUrl && !(photoPayload && photoPayload.base64);
  }

  function buildChatPayload(message, photoPayload) {
    var payload = {
      message: message || "",
      history: history.slice(-8),
      pending_cart_indices: pendingCartIndices.length ? pendingCartIndices : undefined,
      session_id: ensureChatSessionId(),
    };
    if (!isFreshCatalogSearch(message)) {
      payload.last_wines = lastWines.slice(
        0,
        resolveMaxWineResults("", message)
      );
    }
    if (photoPayload && photoPayload.base64) {
      payload.image_base64 = photoPayload.base64;
      payload.image_media_type = photoPayload.mediaType || "image/jpeg";
    }
    return payload;
  }

  function applyChatResponse(data, message, photoPayload) {
    var reply = normalizeChatReply(data);
    var wines = data.wines || [];
    var maxResults = resolveMaxWineResults(data.mode || "", message);
    if (wines.length) {
      lastWines = wines.slice(0, maxResults);
    }
    if (Array.isArray(data.pending_cart_indices) && data.pending_cart_indices.length) {
      pendingCartIndices = data.pending_cart_indices.slice();
    } else if (
      data.mode === "cart_confirmed" ||
      data.mode === "cart_confirmed_all" ||
      data.mode === "cart_declined"
    ) {
      pendingCartIndices = [];
    }
    appendBotReply(reply, wines, message, {
      mode: data.mode || "",
      cardsOnly: !!data.cards_only,
      hero_image_url: data.hero_image_url || "",
    });
    applyClearCartPayload(data.clear_cart);
    applyAddToCartPayload(data.add_to_cart, message);
    history.push({
      role: "user",
      text: historyTextForTurn(message, !!(photoPayload && photoPayload.base64)),
    });
    history.push({
      role: "assistant",
      text: data.cards_only && wines.length ? "" : reply,
    });
    saveChatSession();
  }

  function fetchStreamToken() {
    return fetch(CONFIG.streamTokenUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var detail = data && data.detail ? data.detail : "Could not start streaming.";
          throw new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
        }
        if (!data || !data.token) throw new Error("Missing stream token.");
        return data.token;
      });
    });
  }

  function promoteLoadingToStreamingBot(loadingNode) {
    loadingNode.classList.remove("sens-ai-msg--loading");
    var bubble = loadingNode.querySelector(".sens-ai-msg__bubble");
    if (bubble) {
      bubble.dataset.streamText = "";
      bubble.innerHTML = "";
    }
    return loadingNode;
  }

  function updateStreamingBotBubble(loadingNode, text) {
    var bubble = loadingNode && loadingNode.querySelector(".sens-ai-msg__bubble");
    if (!bubble) return;
    bubble.dataset.streamText = (bubble.dataset.streamText || "") + String(text || "");
    if (isCyberChatTheme()) return;
    var streamWines = [];
    if (bubble.dataset.replyWines) {
      try {
        streamWines = JSON.parse(bubble.dataset.replyWines);
      } catch (e) {
        streamWines = [];
      }
    }
    bubble.innerHTML = formatReply(bubble.dataset.streamText, streamWines);
    scrollMessages();
  }

  function setStreamingStatus(loadingNode, message) {
    var bubble = loadingNode && loadingNode.querySelector(".sens-ai-msg__bubble");
    if (!bubble) return;
    bubble.innerHTML = formatReply(message || LOADING_MESSAGE, []);
    scrollMessages();
  }

  function parseSseBlock(block, handlers) {
    if (!block || !block.trim()) return;
    var lines = block.split("\n");
    var eventName = "message";
    var dataLines = [];
    lines.forEach(function (line) {
      if (line.indexOf("event:") === 0) {
        eventName = line.slice(6).trim() || "message";
      } else if (line.indexOf("data:") === 0) {
        dataLines.push(line.slice(5).trim());
      }
    });
    if (!dataLines.length) return;
    var raw = dataLines.join("\n");
    var payload = raw;
    try {
      payload = JSON.parse(raw);
    } catch (e) {}
    if (handlers[eventName]) handlers[eventName](payload);
    else if (handlers.message) handlers.message(payload, eventName);
  }

  function consumeChatStream(response, loadingNode, message, photoPayload) {
    if (!response.body || !response.body.getReader) {
      throw new Error("Streaming is not supported in this browser.");
    }
    var reader = response.body.getReader();
    var decoder = new TextDecoder("utf-8");
    var buffer = "";
    var streamStarted = false;
    var finalPayload = null;

    function pump() {
      return reader.read().then(function (result) {
        if (result.done) {
          if (finalPayload) return finalPayload;
          throw new Error("Stream ended before Mirai replied.");
        }
        buffer += decoder.decode(result.value, { stream: true });
        var parts = buffer.split("\n\n");
        buffer = parts.pop() || "";
        parts.forEach(function (block) {
          parseSseBlock(block, {
            status: function (payload) {
              if (!streamStarted) {
                setStreamingStatus(
                  loadingNode,
                  payload && payload.message ? payload.message : LOADING_MESSAGE
                );
              }
            },
            delta: function (payload) {
              if (!streamStarted) {
                promoteLoadingToStreamingBot(loadingNode);
                streamStarted = true;
              }
              if (payload && payload.text) updateStreamingBotBubble(loadingNode, payload.text);
            },
            done: function (payload) {
              finalPayload = payload || {};
            },
            error: function (payload) {
              var detail =
                payload && payload.detail
                  ? payload.detail
                  : "Sorry, something went wrong. Please try again.";
              throw new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
            },
          });
        });
        if (finalPayload) return finalPayload;
        return pump();
      });
    }

    return pump().then(function (data) {
      loadingNode.remove();
      applyChatResponse(data, message, photoPayload);
      return data;
    });
  }

  function sendChatRequestStreaming(message, photoPayload, payload, loadingNode) {
    return fetchStreamToken()
      .then(function (token) {
        var fetchOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "text/event-stream",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(payload),
        };
        if (currentAbortController) {
          fetchOptions.signal = currentAbortController.signal;
        }
        return fetch(CONFIG.streamApiUrl, fetchOptions);
      })
      .then(function (res) {
        if (!res.ok) {
          return res.text().then(function (bodyText) {
            var detail = "Stream request failed.";
            try {
              var parsed = JSON.parse(bodyText);
              if (parsed && parsed.detail) detail = parsed.detail;
            } catch (e) {}
            throw new Error(typeof detail === "string" ? detail : String(detail));
          });
        }
        return consumeChatStream(res, loadingNode, message, photoPayload);
      });
  }

  function sendChatRequestClassic(message, photoPayload, payload, loadingNode) {
    var fetchOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    };
    if (currentAbortController) {
      fetchOptions.signal = currentAbortController.signal;
    }
    return fetch(CONFIG.apiUrl, fetchOptions)
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var detail = data && data.detail ? data.detail : "Request failed";
            throw new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
          }
          return data;
        });
      })
      .then(function (data) {
        loadingNode.remove();
        applyChatResponse(data, message, photoPayload);
        return data;
      });
  }

  function sendChatRequest(message, photoPayload) {
    var payload = buildChatPayload(message, photoPayload);
    busy = true;
    panel.classList.add("is-busy");
    if (attachBtnEl) attachBtnEl.disabled = true;
    var loadingNode = appendMessage("bot", LOADING_MESSAGE, "sens-ai-msg--loading");

    currentAbortController = window.AbortController ? new AbortController() : null;

    var requestPromise = shouldUseStreaming(photoPayload)
      ? sendChatRequestStreaming(message, photoPayload, payload, loadingNode).catch(function () {
          return sendChatRequestClassic(message, photoPayload, payload, loadingNode);
        })
      : sendChatRequestClassic(message, photoPayload, payload, loadingNode);

    return requestPromise
      .catch(function (err) {
        loadingNode.remove();
        if (err && err.name === "AbortError") {
           // User cancelled the request
           showToast("Request cancelled");
        } else {
           appendMessage("bot", "Sorry, something went wrong. Please try again.");
           showToast(err && err.message ? String(err.message).slice(0, 100) : "Network error");
           saveChatSession();
        }
      })
      .finally(function () {
        busy = false;
        panel.classList.remove("is-busy");
        // sendEl.disabled = false;
        if (attachBtnEl) attachBtnEl.disabled = false;
        currentAbortController = null;
        inputEl.focus();
      });
  }

  function showToast(message) {
    toastEl.textContent = message;
    toastEl.hidden = false;
    toastEl.classList.add("is-visible");
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(function () {
      toastEl.classList.remove("is-visible");
      window.setTimeout(function () { toastEl.hidden = true; }, 260);
    }, 2600);
  }

  function startNewChat() {
    if (busy) {
      showToast("Please wait for the current reply…");
      return;
    }
    history = [];
    lastWines = [];
    pendingCartIndices = [];
    rotateChatSessionId();
    clearChatSession();
    messagesEl.innerHTML = "";
    var welcome = document.createElement("div");
    welcome.className = "sens-ai-msg sens-ai-msg--bot";
    welcome.appendChild(createButlerSender());
    var stack = document.createElement("div");
    stack.className = "sens-ai-msg__stack";
    var bubble = document.createElement("div");
    bubble.className = "sens-ai-msg__bubble";
    bubble.textContent = WELCOME_MESSAGE;
    stack.appendChild(bubble);
    welcome.appendChild(stack);
    messagesEl.appendChild(welcome);
    inputEl.value = "";
    resetInputHeight();
    clearPendingPhoto();
    closeAttachMenu();
    if (!isMinimized) inputEl.focus();
    saveChatSession();
    showToast("New chat started");
  }

  function lastUserMessageText() {
    for (var i = history.length - 1; i >= 0; i--) {
      if (history[i].role === "user" && history[i].text) return history[i].text;
    }
    return "";
  }

  function messagePrefersChinese(text) {
    return /[\u3400-\u9FFF]/.test(String(text || ""));
  }

  function getCartAddFailMessage(recentText) {
    if (messagePrefersChinese(recentText || lastUserMessageText())) {
      return CART_ADD_FAIL_MESSAGE_ZH;
    }
    return CART_ADD_FAIL_MESSAGE_EN;
  }

  function showMiraiCartAddFail(recentText) {
    var msg = getCartAddFailMessage(recentText);
    appendMessage("bot", msg);
    history.push({ role: "assistant", text: msg });
    saveChatSession();
  }

  var cartOpChain = Promise.resolve();

  function runCartOp(fn) {
    var op = cartOpChain.then(fn);
    cartOpChain = op.catch(function () {});
    return op;
  }

  function isCartPage() {
    return /^\/cart\/?$/i.test(window.location.pathname || "");
  }

  function parseCartAddError(res, data) {
    if (data && data.description) return String(data.description);
    if (data && data.message) return String(data.message);
    if (res && res.status) return "Cart request failed (" + res.status + ").";
    return "cart";
  }

  function refreshCartPageSection() {
    return fetch("/cart?section_id=cart-template", {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "text/html" },
    })
      .then(function (res) {
        if (!res.ok) throw new Error("section");
        return res.text();
      })
      .then(function (html) {
        var section = document.getElementById("shopify-section-cart-template");
        if (section) {
          section.innerHTML = html;
          return;
        }
        window.location.reload();
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function refreshThemeCartAfterUpdate() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    return fetch("/cart.js", {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart");
        return res.json();
      })
      .then(function (cart) {
        var count = cart && typeof cart.item_count === "number" ? cart.item_count : 0;
        document.querySelectorAll(".cart_button .cart_count").forEach(function (el) {
          el.textContent = String(count);
        });
        if (window.jQuery) {
          window.jQuery.getJSON("/cart.js", function (liveCart) {
            if (liveCart && typeof liveCart.item_count === "number") {
              window.jQuery(".cart_button .cart_count").text(liveCart.item_count);
            }
          });
        }
        if (isCartPage()) {
          return refreshCartPageSection();
        }
      })
      .catch(function () {
        if (isCartPage()) {
          return refreshCartPageSection();
        }
      });
  }

  function addVariantToCart(variantId, onDone, options) {
    addVariantsToCart(variantId ? [variantId] : [], onDone, options);
  }

  function addVariantsToCart(variantIds, onDone, options) {
    options = options || {};
    var ids = (variantIds || [])
      .map(function (id) {
        return Number(id);
      })
      .filter(function (id) {
        return id > 0;
      });
    if (!ids.length) {
      if (options.miraiOnFail !== false) showMiraiCartAddFail(options.recentText);
      if (onDone) onDone(false);
      return;
    }
    runCartOp(function () {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          items: ids.map(function (id) {
            return { id: id, quantity: 1 };
          }),
        }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(parseCartAddError(res, data));
            return data;
          });
        })
        .then(function () {
          showToast(ids.length > 1 ? "Added " + ids.length + " to cart" : "Added to cart");
          return refreshThemeCartAfterUpdate();
        })
        .then(function () {
          if (onDone) onDone(true);
        })
        .catch(function (err) {
          if (options.miraiOnFail !== false) showMiraiCartAddFail(options.recentText);
          if (err && err.message && err.message !== "cart") {
            showToast(String(err.message).slice(0, 120));
          }
          if (onDone) onDone(false);
        });
    });
  }

  function applyClearCartPayload(clearCart) {
    if (!clearCart) return;
    runCartOp(function () {
      return fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(parseCartAddError(res, data));
            return data;
          });
        })
        .then(function () {
          showToast("Cart cleared");
          return refreshThemeCartAfterUpdate();
        })
        .catch(function () {
          showToast("Could not clear cart — please try again");
        });
    });
  }

  function applyAddToCartPayload(addPayload, recentText) {
    if (!addPayload) return;
    if (Array.isArray(addPayload.items) && addPayload.items.length) {
      addVariantsToCart(
        addPayload.items.map(function (item) {
          return item && item.variant_id;
        }),
        null,
        { recentText: recentText }
      );
      return;
    }
    if (addPayload.variant_id) {
      addVariantToCart(addPayload.variant_id, null, { recentText: recentText });
    }
  }

  messagesEl.addEventListener("click", function (event) {
    var scrollHint = event.target.closest(".sens-ai-wine-scroll-hint");
    if (scrollHint) {
      event.preventDefault();
      var carousel = scrollHint.closest(".sens-ai-wine-carousel");
      var grid = carousel && carousel.querySelector(".sens-ai-wine-grid");
      scrollWineCarouselToNext(grid);
      return;
    }
    var readMoreBtn = event.target.closest(".sens-ai-read-more__btn");
    if (readMoreBtn) {
      event.preventDefault();
      toggleReadMore(readMoreBtn);
      return;
    }
    var btn = event.target.closest("[data-variant-id]");
    if (!btn) {
      var card = event.target.closest(".sens-ai-wine-card[data-product-url]");
      if (card && !isInteractiveCardTarget(event.target)) {
        openWineCardProduct(card);
      }
      return;
    }
    if (btn.disabled) return;
    var variantId = btn.getAttribute("data-variant-id");
    btn.disabled = true;
    btn.textContent = "Adding…";
    addVariantToCart(
      variantId,
      function (ok) {
        btn.textContent = ok ? "Added ✓" : "Add";
        if (!ok) btn.disabled = false;
      },
      { recentText: lastUserMessageText() }
    );
  });

  messagesEl.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    var card = event.target.closest(".sens-ai-wine-card[data-product-url]");
    if (!card || event.target !== card) return;
    event.preventDefault();
    openWineCardProduct(card);
  });

  formEl.addEventListener("submit", function (event) {
    event.preventDefault();
    if (busy) {
      if (currentAbortController) {
        currentAbortController.abort();
        currentAbortController = null;
      }
      return;
    }
    closeAttachMenu();
    var message = (inputEl.value || "").trim();
    var photoPayload = pendingPhoto;
    if (isHiddenWineExportCommand(message) && !(photoPayload && photoPayload.base64)) {
      inputEl.value = "";
      resetInputHeight();
      if (isMinimized) openPanel();
      exportShownWinesSpreadsheet();
      return;
    }
    if (message.length < 2 && !(photoPayload && photoPayload.base64)) return;
    if (isMinimized) openPanel();
    var bubblePhotoUrl = photoPayload ? clonePreviewUrl(photoPayload) : "";
    appendUserOrBotMessage("user", message, "", bubblePhotoUrl);
    inputEl.value = "";
    resetInputHeight();
    var sentPhoto = photoPayload;
    clearPendingPhoto();
    sendChatRequest(message, sentPhoto);
  });

  if (attachBtnEl && attachMenuEl && uploadImageBtnEl && photoInputEl) {
    attachBtnEl.addEventListener("click", function (event) {
      event.stopPropagation();
      if (busy) return;
      toggleAttachMenu();
    });
    uploadImageBtnEl.addEventListener("click", function () {
      if (busy) return;
      closeAttachMenu();
      openPhotoPicker(false);
    });
    if (takePhotoBtnEl) {
      takePhotoBtnEl.addEventListener("click", function () {
        if (busy) return;
        closeAttachMenu();
        openPhotoPicker(true);
      });
    }
    photoInputEl.addEventListener("change", function () {
      var file = photoInputEl.files && photoInputEl.files[0];
      handlePhotoFileSelected(file);
    });
    document.addEventListener("click", function (event) {
      if (!attachMenuOpen) return;
      var target = event.target;
      if (attachMenuEl && attachMenuEl.contains(target)) return;
      if (attachBtnEl && attachBtnEl.contains(target)) return;
      closeAttachMenu();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && attachMenuOpen) closeAttachMenu();
    });
  }

  if (photoRemoveEl) {
    photoRemoveEl.addEventListener("click", function () {
      clearPendingPhoto();
    });
  }

  inputEl.addEventListener("keydown", function (event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      formEl.requestSubmit();
    }
  });

  inputEl.addEventListener("input", growInputHeight);

  inputEl.addEventListener("focus", function () {
    if (!isMobile()) return;
    panel.classList.add("sens-ai-panel--input-focused");
    syncMobileInputFocus();
  });

  inputEl.addEventListener("blur", function () {
    panel.classList.remove("sens-ai-panel--input-focused");
    if (!isMobile()) return;
    window.setTimeout(function () {
      syncMobileViewport();
      resetMobilePageZoom();
    }, 120);
  });

  window.addEventListener("pagehide", saveChatSession);
  document.addEventListener("click", handleWineProductNavigation, true);

  if (themeToggleBtn) {
    themeToggleBtn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      toggleChatTheme();
    });
  }

  applyChatTheme(loadChatThemePreference());
  syncMobileMode();
  syncMaximizeButton();
  initPanelPosition();
})();
